// import * as Yup from "yup";

// import { Button, Card, Col, Row } from "@themesberg/react-bootstrap";
// import { CountryDropdown, RegionDropdown } from "react-country-region-selector";
// import { ErrorMessage, Field, Form, Formik } from "formik";
// import React, { useEffect, useState } from "react";
// import { selectSitetype, selectjobtype } from "../SelectOption";
// import {
//   getCustomerList,
//   getDealerList,
//   getServiceEngineerList,
// } from "../master/AllUserDropDown";
// import { getListOfUserById } from "../../Service/AllAccessGetById";
// import {
//   getDispatchListByDispenserSrNo,
//   getWorkOrderNoDropDown,
// } from "../../Service/AllWorkOrder";
// import {
//   getDispenserDropDownListForCalibration,
//   getWorkOrderCalibrationSrNo,
//   postWorkOrderCalibration,
// } from "../../Service/AllWorkOrderCalibrationAPI";

// import DatePicker from "react-datepicker";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { Link } from "react-router-dom";
// import Select from "react-select";
// import TextError from "../TextError";
// import ToolTip from "../ToolTip";
// import { faClipboard } from "@fortawesome/free-solid-svg-icons";
// import moment from "moment";
// import swal from "sweetalert";

// const pincodeRegEx = "^[1-9]{1}[0-9]{2}[0-9]{3}$"; //validate PinCode
// const phoneRegEx = "^([0|+[0-9]{1,5})?([7-9][0-9]{9})$";
// /* declaration of validationSchema
// validation (based on the object schema provided by Yup) and display of validation errors */
// const validationSchema = Yup.object({
//   serviceEngineerName: Yup.string().required("Required *"),
//   jobPreference: Yup.string().required("Required *"),
//   subOprationType: Yup.string().required("Required *"),
//   siteType: Yup.string().required("Required *"),
//   siteLocation: Yup.string().required("Required *"),
//   address: Yup.string().required("Required *"),
//   // mobileNo: Yup.string()
//   //   .matches(/^[0-9\s]+$/, "Enter Numbers Only")
//   //   .test("valid-phone", "Invalid Mobile number", (value) => {
//   //     if (!value) return false;
//   //     const cleanedNumber = value.replace(/\s/g, "");
//   //     return /^\d{10}$/.test(cleanedNumber);
//   //   })
//   //   .matches(/^\d{10}$/, "Mobile number must be exactly 10 digits")
//   //   .matches(phoneRegEx, "Mobile number is not valid"),
//   city: Yup.string().required("Required *")

//     .matches(/^[A-Za-z\s]+$/, "Enter only alphabets")
//     .min(2, "Too Short!"),
//   pincode: Yup.string()
//     .required("Required *")
//     .matches(pincodeRegEx, "Pincode is not valid"),
//   description: Yup.string()
//     .required("Required *")
//     .min(4, "It should have minimum 4 characters!")
//     .max(225, "It should have maximum 225 characters!"),
// });
// export default () => {
//   const [country, setCountry] = useState("India");
//   const [state, setState] = useState("");
//   const [customerName, setCustomerName] = useState([]);
//   const [dealerName, setDealerName] = useState([]);
//   const [userMblNo, setUserMblNo] = useState("");
//   const [userEmailId, setUserEmailId] = useState("");
//   const [serviceEngineerName, setServiceEngineerName] = useState([]);
//   const [selectedServiceEngineer, setSelectedServiceEngineer] = useState("");
//   const [jobType, setjobType] = useState("calibration");
//   const [workOrderSrNo, setworkOrderSrNo] = useState("");
//   // const [status, setStatus] = useState("open");
//   const [workOrderNo, setWorkOrderNo] = useState([]);
//   const [dispenserSrNo, setDispenserSrNo] = useState([]);
//   const [selectDispenserSrNo, setSelectDispenserSrNo] = useState("");
//   const [allDispenserData, setAllDispenserData] = useState({});
//   const [showdealer, setShowDealer] = useState(false);
//   const [status, setStatus] = useState("ready to calibration");
//   const [disabled, setdisabled] = useState(false);
//   const [isLoaded, setisLoaded] = useState(false);
//   const [selected, setSelected] = useState("");
//   let type = null;
//   const [selectedTime, setSelectedTime] = useState("");
//   const [selectedDate, setSelectedDate] = useState(new Date());
//   const [siteType, setSiteType] = useState(""); // Store the siteType

//   const changeHandler = (e) => {
//     setSiteType(e.value); // Store the selected siteType
//     if (e.value === "COCO") {
//       setShowDealer(false);
//     } else {
//       setShowDealer(true);
//     }
//   };

//   const validateMobile = (value) => {
//     let error;
//     if (!value) {
//       error = "Mobile number is required";
//     } else if (!/^[0-9\s]+$/.test(value)) {
//       error = "Enter numbers only";
//     } else {
//       const cleanedNumber = value.replace(/\s/g, ""); // Remove spaces
//       if (!/^\d{10}$/.test(cleanedNumber)) {
//         error = "Mobile number must be exactly 10 digits";
//       } else if (!/^[6-9]\d{9}$/.test(cleanedNumber)) {
//         error = "Invalid mobile number ";
//       }
//     }
//     return error;
//   };

//   const handleTimeChange = (e) => {
//     setSelectedTime(e.target.value);
//   };

//   const formatTimeTo12Hour = (time24) => {
//     const [hour, minute, second] = time24.split(":");
//     const parsedHour = parseInt(hour, 10);
//     const period = parsedHour >= 12 ? "PM" : "AM";
//     const formattedHour = parsedHour > 12 ? parsedHour - 12 : parsedHour;
//     return `${formattedHour}:${minute}:${second} ${period}`;
//   };

//   const displayFormattedTime = selectedTime
//     ? formatTimeTo12Hour(selectedTime)
//     : "";

//   // useEffect(() => {
//   //   document.addEventListener("keydown", function (event) {
//   //     if (event.keyCode === 13 && event.target.nodeName === "INPUT") {
//   //       var form = event.target.form;
//   //       var index = Array.prototype.indexOf.call(form, event.target);
//   //       form.elements[index + 1].focus();
//   //       event.preventDefault();
//   //     }
//   //   });
//   // }, []);

//   // added this code because of naivagiton error was coimng in ticket service page
//   useEffect(() => {
//   const handleEnterKey = (event) => {
//     if (event.keyCode === 13 && event.target.nodeName === "INPUT") {
//       const form = event.target.form;

//       if (form && form.elements) {
//         const index = Array.prototype.indexOf.call(form.elements, event.target);
//         if (form.elements[index + 1]) {
//           form.elements[index + 1].focus();
//           event.preventDefault();
//         }
//       }
//     }
//   };

//   document.addEventListener("keydown", handleEnterKey);

//   // Cleanup listener on unmount
//   return () => {
//     document.removeEventListener("keydown", handleEnterKey);
//   };
// }, []);


//   useEffect(() => {
//     // Function call to get customers,Dealers and  Service Engineers list
//     getCustomersList();
//     getDealersList();
//     getServiceEngineersList();
//     getWorkOrderList();
//     getDispenserSrNoAllList();
//     // eslint-disable-next-line
//   }, []);

//   // Function declaration of get customers list
//   const getCustomersList = async () => {
//     await getCustomerList().then((result) => {
//       setCustomerName(result);
//     });
//   };

//   // Function declaration of get dealers list
//   const getDealersList = async () => {
//     await getDealerList().then((result) => {
//       setDealerName(result);
//     });
//   };

//   // Function declaration of get Service Engineers list
//   const getServiceEngineersList = async () => {
//     await getServiceEngineerList().then((result) => {
//       setServiceEngineerName(result);
//     });
//   };

//   const getDispenserSrNoAllList = async () => {
//     try {
//       const token = sessionStorage.getItem("token");
//       const headers = { Authorization: `Bearer ${token}` };
//       await getDispenserDropDownListForCalibration(headers)
//         .then((result) => {
//           if (result?.data?.length) {
//             console.log("getDispenserDDLFCalibration result :-", result);
//             let tempCalibrationArray = result.data.map((obj) => {
//               return {
//                 value: `${obj}`,
//                 label: `${obj}`,
//               };
//             }).reverse();

//             setDispenserSrNo(tempCalibrationArray);
//             console.log("getDispenserDDLFCalibration array :-", dispenserSrNo);
//           }
//         })
//         .catch((error) => {
//           console.log("getDispenserDDLFCalibration error :-", error);
//         });
//       return setDispenserSrNo;
//     } catch (error) {
//       console.log("getDispenserDropDownListForCalibration error :-", error);
//     }
//   };

//   const getWorkOrderList = async () => {
//     try {
//       const token = sessionStorage.getItem("token");
//       const headers = { Authorization: `Bearer ${token}` };
//       await getWorkOrderNoDropDown(status, headers)
//         .then((result) => {
//           if (result?.data?.length !== 0) {
//             console.log("Work Order List", result.data);
//             let tempServiceArray = result.data.map((obj) => {
//               return {
//                 id: `${obj}`,
//                 value: `${obj}`,
//                 label: `${obj}`,
//               };
//             });
//             setWorkOrderNo(tempServiceArray);
//             console.log("Work OrderNo DropDown", result.data);
//           }
//         })
//         .catch((error) => {
//           console.log("Work Order List Error", error);
//         });
//       return setWorkOrderNo;
//     } catch (error) {
//       console.log(error);
//     }
//   };

//   const startCalibration = [
//     { value: "Nozzle 1", label: "Nozzle 1" },
//     { value: "Nozzle 2", label: "Nozzle 2" },
//     { value: "Nozzle 3", label: "Nozzle 3" },
//     { value: "Nozzle 4", label: "Nozzle 4" },
//     { value: "Nozzle 5", label: "Nozzle 5" },
//     { value: "Nozzle 6", label: "Nozzle 6" },
//     { value: "Nozzle 7", label: "Nozzle 7" },
//     { value: "Nozzle 8", label: "Nozzle 8" },
//   ];

//   return (
//     <Formik //Formik provides the Form, Field and ErrorMessage
//       initialValues={{
//         //declaration of initialValues
//         generateUniqueDispenserNo: "",
//         calibrationDate: "",
//         calibrationTime: "",
//         serviceEngineerName: "",
//         serviceEngineerMobNo: "",
//         siteLocation: "",
//         siteType: "",
//         email: "",
//         customerName: "",
//         jobPreference: "",
//         oprationType: "",
//         subOprationType: "",
//         customerMobNo: "",
//         // dealerName: "",
//         // dealerMobNo: "",
//         dealerName: allDispenserData.dealerName || "",
//         mobileNo: allDispenserData?.mobileNo || "",
//         dispenserType: "",
//         city: "",
//         address: "",
//         description: "",
//       }}
//       validationSchema={validationSchema} // function call to validationSchema
//       onSubmit={async (values, { resetForm }) => {
//         // declaration of onSubmit callback
//         try {
//           setisLoaded(true);
//           setdisabled(true);
//           let role = sessionStorage.getItem("role");
//           let pkUserId = sessionStorage.getItem("pkUserId");
//           // code that we will 'try' to run
//           const data = {
//             // All Object for add calibration data
//             workOrderSerialNo: workOrderSrNo,
//             generateUniqueDispenserNo: values.generateUniqueDispenserNo,
//             calibrationDate: moment(selectedDate, "DD/MMM/yyyy").format(
//               "yyyy-MM-DD"
//             ),
//             calibrationTime: moment(displayFormattedTime, "hh:mm:ss A").format(
//               "hh:mm:ss A"
//             ),
//             fkServiceEngineerId: selectedServiceEngineer,
//             fkCustomerId: allDispenserData.fkCustomerId,
//             fkDealerId: allDispenserData.fkDealerId,
//             fkBackOfficeId: role === "back office" ? pkUserId : "",
//             serviceEngineerName: values.serviceEngineerName,
//             serviceEngineerMobNo: userMblNo,
//             siteLocation: values.siteLocation,
//             oprationType: "Calibration Start",
//             subOprationType: values.subOprationType,
//             siteType: values.siteType,
//             email: userEmailId,
//             customerName: allDispenserData.customerFullName,
//             customerMobNo: allDispenserData.customerMobileNo,
//             // dealerName: allDispenserData.dealerName,
//             // dealerMobNo: allDispenserData.mobileNo,
//             dealerName: values.siteType === "COCO" ? "" : values.dealerName, // Set null if COCO
//             dealerMobNo: values.siteType === "COCO" ? "" : values.mobileNo, // Set null if COCO
//             dispenserType: allDispenserData.modelName,
//             jobType: jobType,
//             jobPreference: values.jobPreference,
//             country: country,
//             state: state,
//             city: values.city,
//             address: values.address,
//             pincode: values.pincode,
//             description: values.description,
//             // status: status
//           };
//           console.log("Work Order Calibration Data", data);

//           await postWorkOrderCalibration(data)
//             .then((result) => {

//               setisLoaded(false);
//               console.log("Work Order Calibration Result", result);
//               swal("Great", "Calibration Work order created successfully...", "success");

//               setTimeout(() => {
//                 resetForm();
//                 window.location.href = '/work-order/calibration-list';
//               }, 5000);
//             })
//             .catch((error) => {
//               setisLoaded(false);
//               //code to run if there are any problems
//               console.log("Work Order Calibration Error", error);
//               swal(
//                 "Failed",
//                 "Something went wrong please check your internet",
//                 "error"
//               );
//               if (error.response.status === 400) {
//                 console.log("error.response.data :-", error.response.data);
//                 let calibVal = error?.response?.data;
//                 if (calibVal?.generateUniqueDispenserNo !== undefined) {
//                   swal("Failed", "Please Select Dispenser No", "warning");
//                   return false;
//                 }
//                 if (calibVal?.serviceEngineerName !== undefined) {
//                   swal(
//                     "Failed",
//                     "Please Select Service Engineer name",
//                     "warning"
//                   );
//                   return false;
//                 }
//                 if (calibVal?.serviceEngineerMobNo !== undefined) {
//                   swal(
//                     "Failed",
//                     "Please Enter Service Engineer Mobile No",
//                     "warning"
//                   );
//                   return false;
//                 }
//                 if (calibVal?.siteType !== undefined) {
//                   swal("Failed", "Please Select Site Type", "warning");
//                   return false;
//                 }
//                 if (calibVal?.dispenserType !== undefined) {
//                   swal("Failed", "Please Enter Dispenser Type", "warning");
//                   return false;
//                 }
//                 if (calibVal?.country !== undefined) {
//                   swal("Failed", "Please Select Country", "warning");
//                   return false;
//                 }
//                 if (calibVal?.state !== undefined) {
//                   swal("Failed", "Please Select State", "warning");
//                   return false;
//                 }
//                 if (calibVal?.city !== undefined) {
//                   swal("Failed", "Please Enter city", "warning");
//                   return false;
//                 }
//                 if (calibVal?.pincode !== undefined) {
//                   swal("Failed", "Please Enter Pincode", "warning");
//                   return false;
//                 }
//               } else {
//                 swal(
//                   "Failed",
//                   "Something went wrong please check your internet",
//                   "error"
//                 );
//               }
//             });
//         } catch (error) {
//           console.log(error);
//           setisLoaded(false);
//           swal(
//             "Failed",
//             "Something went wrong please check your internet",
//             "error"
//           );
//         }
//       }}
//     >
//       {(formik) => {
//         //Formik provides the Form, Field and ErrorMessage
//         const { isValid, dirty, isSubmitting, handleChange, values, setFieldValue, errors, touched } = formik;
//         const iscalibrationbutton = selectedDate && displayFormattedTime && state && country;
//         const dealerCheck = siteType !== "COCO"
//           ? values.dealerName && values.mobileNo
//           : true;  // If siteType is COCO, dealerName and mobileNo are not required
//         useEffect(() => {
//           if (allDispenserData?.dealerName) {
//             setFieldValue("dealerName", allDispenserData.dealerName);
//           }
//           if (allDispenserData?.mobileNo) {
//             setFieldValue("mobileNo", allDispenserData.mobileNo);
//           }
//         }, [allDispenserData, setFieldValue]);

//         return (
//           <>
//             {isLoaded ? (
//               <div className="reportload"></div>
//             ) : (
//               <>
//                 <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
//                   <div className="d-flex">
//                     <Link
//                       to="calibration-list"
//                       className="fieldLink btn btn-primary"
//                     >
//                       <FontAwesomeIcon icon={faClipboard} className="me-2" />{" "}
//                       Reports
//                       <span className="icon icon-small ms-1"></span>
//                     </Link>
//                   </div>
//                 </div>
//                 <Card border="light" className="bg-white shadow-sm mb-4">
//                   <Card.Body>
//                     <h5 className="head mb-4">Create Calibration Work Order</h5>
//                     <h5 className="SrNo mb-4" align="right">
//                       Calibration Sr No : {workOrderSrNo}
//                     </h5>
//                     {/* react-final-form */}
//                     <Form>
//                       <Row>
//                         <Col md={6} className="mb-3">
//                           <div className="form-group">
//                             <label className="LabelNew mb-1">
//                               {" "}
//                               Dispenser Sr No *{" "}
//                             </label>
//                             <div className="example-wrapper">
//                               <ToolTip
//                                 content="Select Dispenser for Calibration"
//                                 direction="bottom"
//                               >
//                                 <Select
//                                   name="generateUniqueDispenserNo"
//                                   placeholder="Select Dispenser for Calibration "
//                                   options={dispenserSrNo}
//                                   onChange={async (e) => {
//                                     formik.setFieldValue(
//                                       "generateUniqueDispenserNo",
//                                       e.value
//                                     );
//                                     setSelectDispenserSrNo(e.value);
//                                     await getDispatchListByDispenserSrNo(
//                                       e.value
//                                     ).then((result) => {
//                                       console.log(
//                                         "get All Dispenser List only :_",
//                                         result
//                                       );
//                                       console.log(
//                                         "get All Dispenser List",
//                                         result.data[0].customerFullName
//                                       );
//                                       setAllDispenserData(result.data[0]);
//                                       const token =
//                                         sessionStorage.getItem("token");
//                                       const headers = {
//                                         Authorization: `Bearer ${token}`,
//                                       };
//                                       const oprationType = "Calibration Start";
//                                       const customerName =
//                                         result.data[0].customerFullName;
//                                       try {
//                                         getWorkOrderCalibrationSrNo(
//                                           "calibration",
//                                           oprationType,
//                                           customerName,
//                                           headers
//                                         )
//                                           .then((result) => {
//                                             console.log(
//                                               "Work Order Calibration Sr No",
//                                               result
//                                             );
//                                             setworkOrderSrNo(result.data);
//                                           })
//                                           .catch((error) => {
//                                             console.log(
//                                               "Work Order Calibration Error",
//                                               error
//                                             );
//                                           });
//                                       } catch (error) {
//                                         console.log(error);
//                                         swal(
//                                           "Failed",
//                                           "Something went wrong please check your internet",
//                                           "error"
//                                         );
//                                       }
//                                     });
//                                     return setAllDispenserData;
//                                   }}
//                                 />
//                               </ToolTip>
//                             </div>
//                           </div>
//                         </Col>
//                         <Col md={6} className="mb-3">
//                           <div className="form-group">
//                             <label className="LabelNew mb-1">
//                               {" "}
//                               Calibration Date *{" "}
//                             </label>
//                             <br />
//                             <div className="example-wrapper">
//                               <ToolTip
//                                 content="Select Calibration Date"
//                                 direction="bottom"
//                               >
//                                 <DatePicker
//                                   showIcon
//                                   closeOnScroll={true}
//                                   className="form-control"
//                                   dateFormat="dd-MMM-yyyy"
//                                   placeholderText="Select Date"
//                                   selected={selectedDate}
//                                   onChange={(date) => {
//                                     setSelectedDate(date);
//                                   }}
//                                   minDate={new Date()} // Set the minimum selectable date to today
//                                 />
//                               </ToolTip>
//                             </div>
//                           </div>
//                         </Col>
//                         <Col md={6} className="mb-3">
//                           <div className="form-group">
//                             <label className="LabelNew mb-1">
//                               {" "}
//                               Calibration Time *{" "}
//                             </label>
//                             <br />
//                             <div className="time-wrapper">
//                               <div className="allTime">
//                                 <input
//                                   type="time"
//                                   onChange={handleTimeChange}
//                                   className="form-control"
//                                   step="1"
//                                 />
//                               </div>
//                               <div className="addTime">
//                                 <div className="example-wrapper">
//                                   <ToolTip
//                                     content="Select Time from Widget"
//                                     direction="bottom"
//                                   >
//                                     <Field
//                                       className="form-control"
//                                       name="calibrationTime"
//                                       placeholder="Select Time from Widget"
//                                       value={displayFormattedTime}
//                                       readOnly
//                                     />
//                                   </ToolTip>
//                                 </div>
//                               </div>
//                             </div>
//                           </div>
//                         </Col>
//                         <Col md={6} className="mb-3">
//                           <div className="form-group">
//                             <label className="LabelNew mb-1">
//                               {" "}
//                               Service Engineer Name *{" "}
//                             </label>
//                             <div className="example-wrapper">
//                               <ToolTip
//                                 content="Select Service Engineer Name"
//                                 direction="bottom"
//                               >
//                                 <Select
//                                   placeholder="Select Service Engineer Name"
//                                   options={serviceEngineerName}
//                                   onChange={async (e) => {
//                                     formik.setFieldValue(
//                                       "serviceEngineerName",
//                                       e.value
//                                     );
//                                     setSelectedServiceEngineer(e.id);
//                                     const token =
//                                       sessionStorage.getItem("token");
//                                     const headers = {
//                                       Authorization: `Bearer ${token}`,
//                                     };
//                                     await getListOfUserById(e.id, headers).then(
//                                       (result) => {
//                                         console.log(
//                                           "getListOfUserById",
//                                           result.data
//                                         );
//                                         setUserMblNo(result.data.mobileNo);
//                                         setUserEmailId(result.data.email);
//                                       }
//                                     );
//                                   }}
//                                 />
//                               </ToolTip>
//                             </div>
//                             <ErrorMessage
//                               name="serviceEngineerName"
//                               component={TextError}
//                             />
//                           </div>
//                         </Col>
//                         <Col md={6} className="mb-3">
//                           <div className="form-group">
//                             <label className="Label mb-1">
//                               {" "}
//                               Service Engineer Mobile No{" "}
//                             </label>
//                             <Field
//                               type="text"
//                               className="form-control"
//                               name="serviceEngineerMobNo"
//                               value={userMblNo}
//                               placeholder="Mobile No."
//                               readOnly
//                             />
//                           </div>
//                         </Col>
//                         <Col md={6} className="mb-3">
//                           <div className="form-group">
//                             <label className="LabelNew mb-1">
//                               Job Reference
//                             </label>
//                             <div className="example-wrapper">
//                               <ToolTip
//                                 content="Select Job Reference"
//                                 direction="bottom"
//                               >
//                                 <Select
//                                   placeholder="Select Job Reference"
//                                   options={selectjobtype}
//                                   onChange={(e) => {
//                                     formik.setFieldValue(
//                                       "jobPreference",
//                                       e.value
//                                     );
//                                   }}
//                                 />
//                               </ToolTip>
//                             </div>
//                             <ErrorMessage
//                               name="jobPreference"
//                               component={TextError}
//                             />
//                           </div>
//                         </Col>
//                         <Col md={6} className="mb-3">
//                           <div className="form-group">
//                             <label className="LabelNew mb-1">
//                               Site Location *
//                             </label>
//                             <div className="example-wrapper">
//                               <ToolTip
//                                 content="Enter site location"
//                                 direction="bottom"
//                               >
//                                 <Field
//                                   type="text"
//                                   className="form-control"
//                                   name="siteLocation"
//                                   placeholder="Enter Site Location"
//                                   autoComplete="off"
//                                 />
//                               </ToolTip>
//                             </div>
//                             <ErrorMessage
//                               name="siteLocation"
//                               component={TextError}
//                             />
//                           </div>
//                         </Col>
//                         <Col md={6} className="mb-3">
//                           <div className="form-group">
//                             <label className="LabelNew mb-1">Site Type *</label>
//                             <div className="example-wrapper">
//                               <ToolTip
//                                 content="Select Site Type"
//                                 direction="bottom"
//                               >
//                                 <Select
//                                   placeholder="Select Site Type"
//                                   options={selectSitetype}
//                                   onChange={(val) => {
//                                     changeHandler(val);
//                                     formik.setFieldValue("siteType", val.value);
//                                   }}
//                                 />
//                               </ToolTip>
//                             </div>
//                             <ErrorMessage
//                               name="siteType"
//                               component={TextError}
//                             />
//                           </div>
//                         </Col>
//                         <Col md={6} className="mb-3">
//                           <div className="form-group">
//                             <label className="Label mb-1">
//                               {" "}
//                               Operation Type{" "}
//                             </label>
//                             <Field
//                               name="oprationType"
//                               placeholder="Select OTP"
//                               value="Calibration Start"
//                               className="form-control"
//                               readOnly
//                             />
//                           </div>
//                         </Col>
//                         <Col md={6} className="mb-3">
//                           <div className="form-group">
//                             <label className="LabelNew mb-1">
//                               {" "}
//                               Sub Operation Type *{" "}
//                             </label>
//                             <div className="example-wrapper">
//                               <ToolTip
//                                 content="Select Sub Operation Type"
//                                 direction="bottom"
//                               >
//                                 <Select
//                                   name="subOprationType"
//                                   title="Select Sub Operation"
//                                   placeholder="Select Sub Operation"
//                                   options={startCalibration}
//                                   onChange={(e) => {
//                                     formik.setFieldValue(
//                                       "subOprationType",
//                                       e.value
//                                     );
//                                   }}
//                                 />
//                               </ToolTip>
//                             </div>
//                             <ErrorMessage
//                               name="subOprationType"
//                               component={TextError}
//                             />
//                           </div>
//                         </Col>
//                         <Col md={6} className="mb-3">
//                           <div className="form-group">
//                             <label className="Label mb-1">
//                               Service Engineer Email
//                             </label>
//                             <Field
//                               type="email"
//                               className="form-control"
//                               name="email"
//                               value={userEmailId}
//                               placeholder="Service Engineer Email"
//                               readOnly
//                             />
//                           </div>
//                         </Col>
//                         <Col md={6} className="mb-3">
//                           <div className="form-group">
//                             <label className="Label mb-1">Customer Name</label>
//                             <Field
//                               type="text"
//                               className="form-control"
//                               placeholder="Customer Name"
//                               value={allDispenserData.customerFullName}
//                               readOnly
//                             />
//                           </div>
//                         </Col>
//                         <Col md={6} className="mb-3">
//                           <div className="form-group">
//                             <label className="Label mb-1">
//                               {" "}
//                               Customer Mobile No
//                             </label>
//                             <Field
//                               type="text"
//                               name="customerMobNo"
//                               value={allDispenserData.customerMobileNo}
//                               className="form-control"
//                               placeholder="Customer Mobile No"
//                               readOnly
//                             />
//                           </div>
//                         </Col>
//                         {showdealer ? (
//                           <>
//                             <Col md={6} className="mb-3">
//                               <div className="form-group">
//                                 <label className="Label mb-1">
//                                   Dealer Name
//                                 </label>
//                                 <Field
//                                   type="text"
//                                   className="form-control"
//                                   placeholder="Enter Dealer Name "
//                                   name="dealerName"
//                                   autoComplete="off"
//                                   // value={allDispenserData.dealerName}
//                                   value={values.dealerName}
//                                   onChange={handleChange}
//                                 // readOnly
//                                 />
//                               </div>
//                             </Col>
//                             <Col md={6} className="mb-3">
//                               {/* <div className="form-group">
//                                 <label className="Label mb-1">
//                                   {" "}
//                                   Dealer Mobile No{" "}
//                                 </label>
//                                 <Field
//                                   type="text"
//                                   // name="dealerMobNo"
//                                   name="mobileNo"
//                                      maxLength="10"
//                                   className="form-control"
//                                   placeholder="Enter Dealer Mobile No"
//                                   autoComplete="off" 
//                                   // value={allDispenserData.mobileNo}
//                                   value={values.mobileNo}
//                                   onChange={handleChange} // This will allow user to edit dealer name
//                                   // readOnly
//                                 />
//                               </div>
//                               <ErrorMessage
//                               name="mobileNo"
//                               component={TextError}
//                             /> */}
//                               <div className="form-group">
//                                 <label className="Label mb-1">Dealer Mobile No</label>
//                                 <Field
//                                   type="text"
//                                   name="mobileNo"
//                                   autoComplete="off"
//                                   maxLength="10"
//                                   className={`form-control ${errors.mobileNo && touched.mobileNo ? "is-invalid" : ""
//                                     }`}
//                                   placeholder="Enter Dealer Mobile No"
//                                   validate={validateMobile}
//                                 />
//                                 <ErrorMessage name="mobileNo" component="div" className="text-danger" />
//                               </div>
//                             </Col>
//                           </>
//                         ) : null}
//                         <Col md={6} className="mb-3">
//                           <div className="form-group">
//                             <label className="Label mb-1">
//                               {" "}
//                               Dispenser Type{" "}
//                             </label>
//                             <Field
//                               type="text"
//                               className="form-control"
//                               placeholder="Dispenser Type"
//                               value={allDispenserData.modelName}
//                               readOnly
//                             />
//                           </div>
//                         </Col>
//                         <Col md={6} className="mb-3">
//                           <div className="form-group">
//                             <label className="LabelNew mb-1">Address *</label>
//                             <div className="example-wrapper">
//                               <ToolTip
//                                 content="Enter Address"
//                                 direction="bottom"
//                               >
//                                 <Field
//                                   type="text"
//                                   maxLength={100}
//                                   className="form-control"
//                                   name="address"
//                                   placeholder="Enter Address"
//                                   autoComplete="off"
//                                 />
//                               </ToolTip>
//                             </div>
//                             <ErrorMessage
//                               name="address"
//                               component={TextError}
//                             />
//                           </div>
//                         </Col>
//                         <Col md={6} className="mb-3">
//                           <div className="form-group">
//                             <label className="Label mb-1">Country</label>
//                             <div className="example-wrapper">
//                               <ToolTip
//                                 content="Select Country"
//                                 direction="bottom"
//                               >
//                                 <CountryDropdown
//                                   className="form-control"
//                                   value={country}
//                                   onChange={(val) => setCountry(val)}
//                                   priorityOptions={["IN"]}
//                                 />
//                               </ToolTip>
//                             </div>
//                           </div>
//                         </Col>
//                         <Col md={6} className="mb-3">
//                           <div className="form-group">
//                             <label className="Label mb-1">State</label>
//                             <div className="example-wrapper">
//                               <ToolTip
//                                 content="Select State"
//                                 direction="bottom"
//                               >
//                                 <RegionDropdown
//                                   className="form-control"
//                                   id="state"
//                                   country={country}
//                                   value={state}
//                                   onChange={(val) => setState(val)}
//                                 />
//                               </ToolTip>
//                             </div>
//                           </div>
//                         </Col>
//                         <Col md={6} className="mb-3">
//                           <div className="form-group">
//                             <label className="LabelNew mb-1">City *</label>
//                             <div className="example-wrapper">
//                               <ToolTip content="Enter City" direction="bottom">
//                                 <Field
//                                   type="text"
//                                   className="form-control"
//                                   name="city"
//                                   placeholder="Enter City"
//                                   autoComplete="off"
//                                 />
//                               </ToolTip>
//                             </div>
//                             <ErrorMessage name="city" component={TextError} />
//                           </div>
//                         </Col>
//                         <Col md={6} className="mb-3">
//                           <div className="form-group">
//                             <label className="LabelNew mb-1">Pin Code *</label>
//                             <div className="example-wrapper">
//                               <ToolTip
//                                 content="Enter Pin Code"
//                                 direction="bottom"
//                               >
//                                 <Field
//                                   type="text"
//                                   className="form-control"
//                                   name="pincode"
//                                   placeholder="Enter Pin Code"
//                                   maxLength="6"
//                                   autoComplete="off"
//                                 />
//                               </ToolTip>
//                             </div>
//                             <ErrorMessage
//                               name="pincode"
//                               component={TextError}
//                             />
//                           </div>
//                         </Col>
//                         <Col md={6} className="mb-3">
//                           <div className="form-group">
//                             <label className="LabelNew mb-1">
//                               Description *
//                             </label>
//                             <div className="example-wrapper">
//                               <ToolTip
//                                 content="Enter Suitable Description"
//                                 direction="bottom"
//                               >
//                                 <Field
//                                   as="textarea"
//                                   rows="4"
//                                   maxLength={100}
//                                   className="form-control"
//                                   name="description"
//                                   placeholder="Enter Description"
//                                   autoComplete="off"
//                                 />
//                               </ToolTip>
//                             </div>
//                             <ErrorMessage
//                               name="description"
//                               component={TextError}
//                             />
//                           </div>
//                         </Col>
//                       </Row>
//                       <div className="mt-3">
//                         <Button
//                           variant="primary"
//                           type="submit"
//                           disabled={!(formik.isValid && formik.dirty) || formik.isSubmitting || !iscalibrationbutton || !dealerCheck}
//                         >
//                           Create Calibration WO
//                         </Button>
//                       </div>
//                     </Form>
//                   </Card.Body>
//                 </Card>
//               </>
//             )}
//           </>
//         );
//       }}
//     </Formik>
//   );
// };


// this code auto fetching dispernser serial number , city and state
// import * as Yup from "yup";

// import { Button, Card, Col, Row } from "@themesberg/react-bootstrap";
// import { CountryDropdown, RegionDropdown } from "react-country-region-selector";
// import { ErrorMessage, Field, Form, Formik } from "formik";
// import React, { useEffect, useState } from "react";
// import { selectSitetype, selectjobtype } from "../SelectOption";
// import {
//   getCustomerList,
//   getDealerList,
//   getServiceEngineerList,
// } from "../master/AllUserDropDown";
// import { getListOfUserById } from "../../Service/AllAccessGetById";
// import {
//   getDispatchListByDispenserSrNo,
//   getWorkOrderNoDropDown,
// } from "../../Service/AllWorkOrder";
// import {
//   getDispenserDropDownListForCalibration,
//   getWorkOrderCalibrationSrNo,
//   postWorkOrderCalibration,
// } from "../../Service/AllWorkOrderCalibrationAPI";

// import DatePicker from "react-datepicker";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { Link } from "react-router-dom";
// import Select from "react-select";
// import TextError from "../TextError";
// import ToolTip from "../ToolTip";
// import { faClipboard } from "@fortawesome/free-solid-svg-icons";
// import moment from "moment";
// import swal from "sweetalert";
// import { useLocation } from "react-router-dom";

// const pincodeRegEx = "^[1-9]{1}[0-9]{2}[0-9]{3}$"; //validate PinCode
// const phoneRegEx = "^([0|+[0-9]{1,5})?([7-9][0-9]{9})$";
// /* declaration of validationSchema
// validation (based on the object schema provided by Yup) and display of validation errors */
// const validationSchema = Yup.object({
//   serviceEngineerName: Yup.string().required("Required *"),
//   jobPreference: Yup.string().required("Required *"),
//   subOprationType: Yup.string().required("Required *"),
//   siteType: Yup.string().required("Required *"),
//   // siteLocation: Yup.string().required("Required *"),
//   // address: Yup.string().required("Required *"),
//   // mobileNo: Yup.string()
//   //   .matches(/^[0-9\s]+$/, "Enter Numbers Only")
//   //   .test("valid-phone", "Invalid Mobile number", (value) => {
//   //     if (!value) return false;
//   //     const cleanedNumber = value.replace(/\s/g, "");
//   //     return /^\d{10}$/.test(cleanedNumber);
//   //   })
//   //   .matches(/^\d{10}$/, "Mobile number must be exactly 10 digits")
//   //   .matches(phoneRegEx, "Mobile number is not valid"),
//   // city: Yup.string().required("Required *")

//   //   .matches(/^[A-Za-z\s]+$/, "Enter only alphabets")
//   //   .min(2, "Too Short!"),
//   // pincode: Yup.string()
//   //   .required("Required *")
//   //   .matches(pincodeRegEx, "Pincode is not valid"),
//   description: Yup.string()
//     .required("Required *")
//     .min(4, "It should have minimum 4 characters!")
//     .max(225, "It should have maximum 225 characters!"),
// });
// export default () => {
//   const [country, setCountry] = useState("India");
//   const [state, setState] = useState("");
//   const [customerName, setCustomerName] = useState([]);
//   const [dealerName, setDealerName] = useState([]);
//   const [userMblNo, setUserMblNo] = useState("");
//   const [userEmailId, setUserEmailId] = useState("");
//   const [serviceEngineerName, setServiceEngineerName] = useState([]);
//   const [selectedServiceEngineer, setSelectedServiceEngineer] = useState("");
//   const [jobType, setjobType] = useState("calibration");
//   const [workOrderSrNo, setworkOrderSrNo] = useState("");
//   // const [status, setStatus] = useState("open");
//   const [workOrderNo, setWorkOrderNo] = useState([]);
//   const [dispenserSrNo, setDispenserSrNo] = useState([]);
//   const [selectDispenserSrNo, setSelectDispenserSrNo] = useState("");
//   const [allDispenserData, setAllDispenserData] = useState({});
//   const [showdealer, setShowDealer] = useState(false);
//   const [status, setStatus] = useState("ready to calibration");
//   const [disabled, setdisabled] = useState(false);
//   const [isLoaded, setisLoaded] = useState(false);
//   const [selected, setSelected] = useState("");
//   let type = null;
//   const [selectedTime, setSelectedTime] = useState("");
//   const [selectedDate, setSelectedDate] = useState(new Date());
//   const [siteType, setSiteType] = useState(""); // Store the siteType



//   const location = useLocation();


//   const searchParams = new URLSearchParams(location.search);
//   const dispenser = searchParams.get("dispenser") || "N/A";
//   const ticketNumber = searchParams.get("ticket") || "N/A";
//   const priority = searchParams.get("priority") || "N/A";
//   const roCountry = searchParams.get("roCountry") || "N/A";
//   const roCity = searchParams.get("roCity") || "N/A";
//   const roState = searchParams.get("roState") || "N/A";
//   const roAddress = searchParams.get("roAddress") || "N/A";
//   const pincode = searchParams.get("pincode") || "N/A";
//   console.log("Dispenser:", dispenser);
//   console.log("Ticket Number:", ticketNumber);
//   console.log("Priority:", priority);
//   console.log("roCountry:", roCountry);
//   console.log("roCity :", roCity);
//   console.log("roState:", roState);
//   console.log("roAddress", roAddress);
//   console.log("pincode", pincode);


//   const [formValues, setFormValues] = useState({
//     dispenserSrNo: dispenser,
//     ticketNumber: ticketNumber,
//     priority: priority,
//     roCountry: roCountry,
//     roState: roState,
//     roAddress: roAddress,
//     roCity: roCity,
//     pincode:pincode,
//   });





//   const changeHandler = (e) => {
//     setSiteType(e.value); // Store the selected siteType
//     if (e.value === "COCO") {
//       setShowDealer(false);
//     } else {
//       setShowDealer(true);
//     }
//   };

//   const validateMobile = (value) => {
//     let error;
//     if (!value) {
//       error = "Mobile number is required";
//     } else if (!/^[0-9\s]+$/.test(value)) {
//       error = "Enter numbers only";
//     } else {
//       const cleanedNumber = value.replace(/\s/g, ""); // Remove spaces
//       if (!/^\d{10}$/.test(cleanedNumber)) {
//         error = "Mobile number must be exactly 10 digits";
//       } else if (!/^[6-9]\d{9}$/.test(cleanedNumber)) {
//         error = "Invalid mobile number ";
//       }
//     }
//     return error;
//   };

//   const handleTimeChange = (e) => {
//     setSelectedTime(e.target.value);
//   };

//   const formatTimeTo12Hour = (time24) => {
//     const [hour, minute, second] = time24.split(":");
//     const parsedHour = parseInt(hour, 10);
//     const period = parsedHour >= 12 ? "PM" : "AM";
//     const formattedHour = parsedHour > 12 ? parsedHour - 12 : parsedHour;
//     return `${formattedHour}:${minute}:${second} ${period}`;
//   };

//   const displayFormattedTime = selectedTime
//     ? formatTimeTo12Hour(selectedTime)
//     : "";

//   // useEffect(() => {
//   //   document.addEventListener("keydown", function (event) {
//   //     if (event.keyCode === 13 && event.target.nodeName === "INPUT") {
//   //       var form = event.target.form;
//   //       var index = Array.prototype.indexOf.call(form, event.target);
//   //       form.elements[index + 1].focus();
//   //       event.preventDefault();
//   //     }
//   //   });
//   // }, []);

//   // added this code because of naivagiton error was coimng in ticket service page
//   useEffect(() => {
//     const handleEnterKey = (event) => {
//       if (event.keyCode === 13 && event.target.nodeName === "INPUT") {
//         const form = event.target.form;

//         if (form && form.elements) {
//           const index = Array.prototype.indexOf.call(form.elements, event.target);
//           if (form.elements[index + 1]) {
//             form.elements[index + 1].focus();
//             event.preventDefault();
//           }
//         }
//       }
//     };

//     document.addEventListener("keydown", handleEnterKey);

//     // Cleanup listener on unmount
//     return () => {
//       document.removeEventListener("keydown", handleEnterKey);
//     };
//   }, []);



//   useEffect(() => {
//     if (!dispenser) return;

//     console.log("CALIBRATION DISPENSER:", dispenser);

//     const token = sessionStorage.getItem("token");
//     const headers = { Authorization: `Bearer ${token}` };
//     const operationType = "Calibration Start";

//     getDispatchListByDispenserSrNo(dispenser)
//       .then((res) => {
//         if (!res?.data?.length) return;

//         const data = res.data[0];

//         console.log("Calibration Customer Data:", data);

//         setAllDispenserData(data);

//         // Set customer details
//         setFormValues((prev) => ({
//           ...prev,
//           dispenserSrNo: dispenser,
//           customerName: data.customerFullName || "",
//           customerNumber: data.customerMobileNo || "",
//         }));

//         // Get Calibration Work Order SR No
//         return getWorkOrderCalibrationSrNo(
//           "calibration",
//           operationType,
//           data.customerFullName,
//           headers
//         );
//       })
//       .then((woRes) => {
//         if (woRes?.data) {
//           console.log("Calibration Work Order Sr No:", woRes.data);
//           setworkOrderSrNo(woRes.data);
//         }
//       })
//       .catch((err) => {
//         console.error("Calibration Error:", err);
//         swal("Failed", "Something went wrong", "error");
//       });
//   }, [dispenser]);



//   useEffect(() => {
//     // Function call to get customers,Dealers and  Service Engineers list
//     getCustomersList();
//     getDealersList();
//     getServiceEngineersList();
//     getWorkOrderList();
//     getDispenserSrNoAllList();
//     // eslint-disable-next-line
//   }, []);

//   // Function declaration of get customers list
//   const getCustomersList = async () => {
//     await getCustomerList().then((result) => {
//       setCustomerName(result);
//     });
//   };

//   // Function declaration of get dealers list
//   const getDealersList = async () => {
//     await getDealerList().then((result) => {
//       setDealerName(result);
//     });
//   };

//   // Function declaration of get Service Engineers list
//   const getServiceEngineersList = async () => {
//     await getServiceEngineerList().then((result) => {
//       setServiceEngineerName(result);
//     });
//   };

//   const getDispenserSrNoAllList = async () => {
//     try {
//       const token = sessionStorage.getItem("token");
//       const headers = { Authorization: `Bearer ${token}` };
//       await getDispenserDropDownListForCalibration(headers)
//         .then((result) => {
//           if (result?.data?.length) {
//             console.log("getDispenserDDLFCalibration result :-", result);
//             let tempCalibrationArray = result.data.map((obj) => {
//               return {
//                 value: `${obj}`,
//                 label: `${obj}`,
//               };
//             }).reverse();

//             setDispenserSrNo(tempCalibrationArray);
//             console.log("getDispenserDDLFCalibration array :-", dispenserSrNo);
//           }
//         })
//         .catch((error) => {
//           console.log("getDispenserDDLFCalibration error :-", error);
//         });
//       return setDispenserSrNo;
//     } catch (error) {
//       console.log("getDispenserDropDownListForCalibration error :-", error);
//     }
//   };

//   const getWorkOrderList = async () => {
//     try {
//       const token = sessionStorage.getItem("token");
//       const headers = { Authorization: `Bearer ${token}` };
//       await getWorkOrderNoDropDown(status, headers)
//         .then((result) => {
//           if (result?.data?.length !== 0) {
//             console.log("Work Order List", result.data);
//             let tempServiceArray = result.data.map((obj) => {
//               return {
//                 id: `${obj}`,
//                 value: `${obj}`,
//                 label: `${obj}`,
//               };
//             });
//             setWorkOrderNo(tempServiceArray);
//             console.log("Work OrderNo DropDown", result.data);
//           }
//         })
//         .catch((error) => {
//           console.log("Work Order List Error", error);
//         });
//       return setWorkOrderNo;
//     } catch (error) {
//       console.log(error);
//     }
//   };

//   const startCalibration = [
//     { value: "Nozzle 1", label: "Nozzle 1" },
//     { value: "Nozzle 2", label: "Nozzle 2" },
//     { value: "Nozzle 3", label: "Nozzle 3" },
//     { value: "Nozzle 4", label: "Nozzle 4" },
//     { value: "Nozzle 5", label: "Nozzle 5" },
//     { value: "Nozzle 6", label: "Nozzle 6" },
//     { value: "Nozzle 7", label: "Nozzle 7" },
//     { value: "Nozzle 8", label: "Nozzle 8" },
//   ];

//   return (
//     <Formik //Formik provides the Form, Field and ErrorMessage
//       initialValues={{
//         //declaration of initialValues
//         generateUniqueDispenserNo: "",
//         calibrationDate: "",
//         calibrationTime: "",
//         serviceEngineerName: "",
//         serviceEngineerMobNo: "",
//         siteLocation: "",
//         siteType: "",
//         email: "",
//         customerName: "",
//         jobPreference: "",
//         oprationType: "",
//         subOprationType: "",
//         customerMobNo: "",
//         // dealerName: "",
//         // dealerMobNo: "",
//         dealerName: allDispenserData.dealerName || "",
//         mobileNo: allDispenserData?.mobileNo || "",
//         dispenserType: "",
//         city: "",
//         address: "",
//         description: "",
//         pincode: "",
//         dispenserSrNo: "",
//         ticketNumber: "",
//         priority: "",
//         roCountry: "",
//         roCity: "",
//         roState: "",
//         roAddress: "",
//       }}
//       validationSchema={validationSchema} // function call to validationSchema
//       onSubmit={async (values, { resetForm }) => {
//         // declaration of onSubmit callback
//         try {
//           setisLoaded(true);
//           setdisabled(true);
//           let role = sessionStorage.getItem("role");
//           let pkUserId = sessionStorage.getItem("pkUserId");
//           // code that we will 'try' to run
//           const data = {
//             // All Object for add calibration data
//             workOrderSerialNo: workOrderSrNo,
//             // generateUniqueDispenserNo: values.generateUniqueDispenserNo,
//             calibrationDate: moment(selectedDate, "DD/MMM/yyyy").format(
//               "yyyy-MM-DD"
//             ),
//             calibrationTime: moment(displayFormattedTime, "hh:mm:ss A").format(
//               "hh:mm:ss A"
//             ),
//             fkServiceEngineerId: selectedServiceEngineer,
//             fkCustomerId: allDispenserData.fkCustomerId,
//             fkDealerId: allDispenserData.fkDealerId,
//             fkBackOfficeId: role === "back office" ? pkUserId : "",
//             serviceEngineerName: values.serviceEngineerName,
//             serviceEngineerMobNo: userMblNo,
//             siteLocation: values.siteLocation,
//             oprationType: "Calibration Start",
//             subOprationType: values.subOprationType,
//             siteType: values.siteType,
//             email: userEmailId,
//             customerName: allDispenserData.customerFullName,
//             customerMobNo: allDispenserData.customerMobileNo,
//             // dealerName: allDispenserData.dealerName,
//             // dealerMobNo: allDispenserData.mobileNo,
//             dealerName: values.siteType === "COCO" ? "" : values.dealerName, // Set null if COCO
//             dealerMobNo: values.siteType === "COCO" ? "" : values.mobileNo, // Set null if COCO
//             dispenserType: allDispenserData.modelName,
//             jobType: jobType,
//             jobPreference: values.jobPreference,
//             // country: country,
//             // state: state,
//             // city: values.city,
//             // address: values.address,
//             pincode: values.pincode,
//             description: values.description,
//             generateUniqueDispenserNo: formValues.dispenserSrNo,
//             ticketNumber: formValues.ticketNumber,
//             priority: formValues.priority,
//             roCity: formValues.roCity,
//             roAddress: formValues.roAddress,
//             roState: formValues.roState,
//             roCountry: formValues.roCountry,
//             pincode: formValues.pincode,
//             // status: status
//           };
//           console.log("Work Order Calibration Data", data);

//           await postWorkOrderCalibration(data)
//             .then((result) => {

//               setisLoaded(false);
//               console.log("Work Order Calibration Result", result);
//               swal("Great", "Calibration Work order created successfully...", "success");

//               setTimeout(() => {
//                 resetForm();
//                 window.location.href = '/Callcenter/TicketServiceTech ';
//               }, 5000);
//             })
//             .catch((error) => {
//               setisLoaded(false);
//               //code to run if there are any problems
//               console.log("Work Order Calibration Error", error);
//               swal(
//                 "Failed",
//                 "Something went wrong please check your internet",
//                 "error"
//               );
//               if (error.response.status === 400) {
//                 console.log("error.response.data :-", error.response.data);
//                 let calibVal = error?.response?.data;
//                 if (calibVal?.generateUniqueDispenserNo !== undefined) {
//                   swal("Failed", "Please Select Dispenser No", "warning");
//                   return false;
//                 }
//                 if (calibVal?.serviceEngineerName !== undefined) {
//                   swal(
//                     "Failed",
//                     "Please Select Service Engineer name",
//                     "warning"
//                   );
//                   return false;
//                 }
//                 if (calibVal?.serviceEngineerMobNo !== undefined) {
//                   swal(
//                     "Failed",
//                     "Please Enter Service Engineer Mobile No",
//                     "warning"
//                   );
//                   return false;
//                 }
//                 if (calibVal?.siteType !== undefined) {
//                   swal("Failed", "Please Select Site Type", "warning");
//                   return false;
//                 }
//                 if (calibVal?.dispenserType !== undefined) {
//                   swal("Failed", "Please Enter Dispenser Type", "warning");
//                   return false;
//                 }
//                 // if (calibVal?.country !== undefined) {
//                 //   swal("Failed", "Please Select Country", "warning");
//                 //   return false;
//                 // }
//                 // if (calibVal?.state !== undefined) {
//                 //   swal("Failed", "Please Select State", "warning");
//                 //   return false;
//                 // }
//                 // if (calibVal?.city !== undefined) {
//                 //   swal("Failed", "Please Enter city", "warning");
//                 //   return false;
//                 // }
//                 if (calibVal?.pincode !== undefined) {
//                   swal("Failed", "Please Enter Pincode", "warning");
//                   return false;
//                 }
//               } else {
//                 swal(
//                   "Failed",
//                   "Something went wrong please check your internet",
//                   "error"
//                 );
//               }
//             });
//         } catch (error) {
//           console.log(error);
//           setisLoaded(false);
//           swal(
//             "Failed",
//             "Something went wrong please check your internet",
//             "error"
//           );
//         }
//       }}
//     >
//       {(formik) => {
//         //Formik provides the Form, Field and ErrorMessage
//         const { isValid, dirty, isSubmitting, handleChange, values, setFieldValue, errors, touched } = formik;
//         const iscalibrationbutton = selectedDate && displayFormattedTime 
//         const dealerCheck = siteType !== "COCO"
//           ? values.dealerName && values.mobileNo
//           : true;  // If siteType is COCO, dealerName and mobileNo are not required
//         useEffect(() => {
//           if (allDispenserData?.dealerName) {
//             setFieldValue("dealerName", allDispenserData.dealerName);
//           }
//           if (allDispenserData?.mobileNo) {
//             setFieldValue("mobileNo", allDispenserData.mobileNo);
//           }
//         }, [allDispenserData, setFieldValue]);

//         return (
//           <>
//             {isLoaded ? (
//               <div className="reportload"></div>
//             ) : (
//               <>
//                 <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
//                   <div className="d-flex">
//                     <Link
//                       to="calibration-list"
//                       className="fieldLink btn btn-primary"
//                     >
//                       <FontAwesomeIcon icon={faClipboard} className="me-2" />{" "}
//                       Reports
//                       <span className="icon icon-small ms-1"></span>
//                     </Link>
//                   </div>
//                 </div>
//                 <Card border="light" className="bg-white shadow-sm mb-4">
//                   <Card.Body>
//                     <h5 className="head mb-4">Create Calibration Work Order</h5>
//                     <h5 className="SrNo mb-4" align="right">
//                       Calibration Sr No : {workOrderSrNo}
//                     </h5>
//                     {/* react-final-form */}
//                     <Form>
//                       <Row>
//                         {/* <Col md={6} className="mb-3">
//                           <div className="form-group">
//                             <label className="LabelNew mb-1">
//                               {" "}
//                               Dispenser Sr No *{" "}
//                             </label>
//                             <div className="example-wrapper">
//                               <ToolTip
//                                 content="Select Dispenser for Calibration"
//                                 direction="bottom"
//                               >
//                                 <Select
//                                   name="generateUniqueDispenserNo"
//                                   placeholder="Select Dispenser for Calibration "
//                                   options={dispenserSrNo}
//                                   onChange={async (e) => {
//                                     formik.setFieldValue(
//                                       "generateUniqueDispenserNo",
//                                       e.value
//                                     );
//                                     setSelectDispenserSrNo(e.value);
//                                     await getDispatchListByDispenserSrNo(
//                                       e.value
//                                     ).then((result) => {
//                                       console.log(
//                                         "get All Dispenser List only :_",
//                                         result
//                                       );
//                                       console.log(
//                                         "get All Dispenser List",
//                                         result.data[0].customerFullName
//                                       );
//                                       setAllDispenserData(result.data[0]);
//                                       const token =
//                                         sessionStorage.getItem("token");
//                                       const headers = {
//                                         Authorization: `Bearer ${token}`,
//                                       };
//                                       const oprationType = "Calibration Start";
//                                       const customerName =
//                                         result.data[0].customerFullName;
//                                       try {
//                                         getWorkOrderCalibrationSrNo(
//                                           "calibration",
//                                           oprationType,
//                                           customerName,
//                                           headers
//                                         )
//                                           .then((result) => {
//                                             console.log(
//                                               "Work Order Calibration Sr No",
//                                               result
//                                             );
//                                             setworkOrderSrNo(result.data);
//                                           })
//                                           .catch((error) => {
//                                             console.log(
//                                               "Work Order Calibration Error",
//                                               error
//                                             );
//                                           });
//                                       } catch (error) {
//                                         console.log(error);
//                                         swal(
//                                           "Failed",
//                                           "Something went wrong please check your internet",
//                                           "error"
//                                         );
//                                       }
//                                     });
//                                     return setAllDispenserData;
//                                   }}
//                                 />
//                               </ToolTip>
//                             </div>
//                           </div>
//                         </Col> */}


//                         <Col md={6} className="mb-3">


//                           <div className="form-group">
//                             <label className="Label mb-1">
//                               Dispenser Sr No

//                             </label>
//                             <Field
//                               type="text"
//                               className="form-control"
//                               placeholder="Dispenser Type"
//                               value={formValues.dispenserSrNo}
//                               readOnly
//                             />
//                           </div>
//                         </Col>
//                         <Col md={6} className="mb-3">
//                           <div className="form-group">
//                             <label className="Label mb-1">
//                               Ticket Number
//                             </label>
//                             <Field
//                               type="text"
//                               className="form-control"
//                               placeholder="Dispenser Type"
//                               value={formValues.ticketNumber}
//                               readOnly
//                             />
//                           </div>
//                         </Col>

//                         <Col md={6} className="mb-3">
//                           <div className="form-group">
//                             <label className="Label mb-1">
//                               Priority

//                             </label>
//                             <Field
//                               type="text"
//                               className="form-control"
//                               placeholder="Dispenser Type"
//                               value={formValues.priority}
//                               readOnly
//                             />
//                           </div>




//                         </Col>
//                         <Col md={6} className="mb-3">
//                           <div className="form-group">
//                             <label className="LabelNew mb-1">
//                               {" "}
//                               Calibration Date *{" "}
//                             </label>
//                             <br />
//                             <div className="example-wrapper">
//                               <ToolTip
//                                 content="Select Calibration Date"
//                                 direction="bottom"
//                               >
//                                 <DatePicker
//                                   showIcon
//                                   closeOnScroll={true}
//                                   className="form-control"
//                                   dateFormat="dd-MMM-yyyy"
//                                   placeholderText="Select Date"
//                                   selected={selectedDate}
//                                   onChange={(date) => {
//                                     setSelectedDate(date);
//                                   }}
//                                   minDate={new Date()} // Set the minimum selectable date to today
//                                 />
//                               </ToolTip>
//                             </div>
//                           </div>
//                         </Col>
//                         <Col md={6} className="mb-3">
//                           <div className="form-group">
//                             <label className="LabelNew mb-1">
//                               {" "}
//                               Calibration Time *{" "}
//                             </label>
//                             <br />
//                             <div className="time-wrapper">
//                               <div className="allTime">
//                                 <input
//                                   type="time"
//                                   onChange={handleTimeChange}
//                                   className="form-control"
//                                   step="1"
//                                 />
//                               </div>
//                               <div className="addTime">
//                                 <div className="example-wrapper">
//                                   <ToolTip
//                                     content="Select Time from Widget"
//                                     direction="bottom"
//                                   >
//                                     <Field
//                                       className="form-control"
//                                       name="calibrationTime"
//                                       placeholder="Select Time from Widget"
//                                       value={displayFormattedTime}
//                                       readOnly
//                                     />
//                                   </ToolTip>
//                                 </div>
//                               </div>
//                             </div>
//                           </div>
//                         </Col>
//                         <Col md={6} className="mb-3">
//                           <div className="form-group">
//                             <label className="LabelNew mb-1">
//                               {" "}
//                               Service Engineer Name *{" "}
//                             </label>
//                             <div className="example-wrapper">
//                               <ToolTip
//                                 content="Select Service Engineer Name"
//                                 direction="bottom"
//                               >
//                                 <Select
//                                   placeholder="Select Service Engineer Name"
//                                   options={serviceEngineerName}
//                                   onChange={async (e) => {
//                                     formik.setFieldValue(
//                                       "serviceEngineerName",
//                                       e.value
//                                     );
//                                     setSelectedServiceEngineer(e.id);
//                                     const token =
//                                       sessionStorage.getItem("token");
//                                     const headers = {
//                                       Authorization: `Bearer ${token}`,
//                                     };
//                                     await getListOfUserById(e.id, headers).then(
//                                       (result) => {
//                                         console.log(
//                                           "getListOfUserById",
//                                           result.data
//                                         );
//                                         setUserMblNo(result.data.mobileNo);
//                                         setUserEmailId(result.data.email);
//                                       }
//                                     );
//                                   }}
//                                 />
//                               </ToolTip>
//                             </div>
//                             <ErrorMessage
//                               name="serviceEngineerName"
//                               component={TextError}
//                             />
//                           </div>
//                         </Col>
//                         <Col md={6} className="mb-3">
//                           <div className="form-group">
//                             <label className="Label mb-1">
//                               {" "}
//                               Service Engineer Mobile No{" "}
//                             </label>
//                             <Field
//                               type="text"
//                               className="form-control"
//                               name="serviceEngineerMobNo"
//                               value={userMblNo}
//                               placeholder="Mobile No."
//                               readOnly
//                             />
//                           </div>
//                         </Col>
//                         <Col md={6} className="mb-3">
//                           <div className="form-group">
//                             <label className="LabelNew mb-1">
//                               Job Reference
//                             </label>
//                             <div className="example-wrapper">
//                               <ToolTip
//                                 content="Select Job Reference"
//                                 direction="bottom"
//                               >
//                                 <Select
//                                   placeholder="Select Job Reference"
//                                   options={selectjobtype}
//                                   onChange={(e) => {
//                                     formik.setFieldValue(
//                                       "jobPreference",
//                                       e.value
//                                     );
//                                   }}
//                                 />
//                               </ToolTip>
//                             </div>
//                             <ErrorMessage
//                               name="jobPreference"
//                               component={TextError}
//                             />
//                           </div>
//                         </Col>
//                         <Col md={6} className="mb-3">
//                           <div className="form-group">
//                             <label className="LabelNew mb-1">
//                               Site Location *
//                             </label>
//                             <div className="example-wrapper">
//                               <ToolTip
//                                 content="Enter site location"
//                                 direction="bottom"
//                               >
//                                 <Field
//                                   type="text"
//                                   className="form-control"
//                                   name="siteLocation"
//                                   placeholder="Enter Site Location"
//                                   autoComplete="off"
//                                 />
//                               </ToolTip>
//                             </div>
//                             <ErrorMessage
//                               name="siteLocation"
//                               component={TextError}
//                             />
//                           </div>
//                         </Col>
//                         <Col md={6} className="mb-3">
//                           <div className="form-group">
//                             <label className="LabelNew mb-1">Site Type *</label>
//                             <div className="example-wrapper">
//                               <ToolTip
//                                 content="Select Site Type"
//                                 direction="bottom"
//                               >
//                                 <Select
//                                   placeholder="Select Site Type"
//                                   options={selectSitetype}
//                                   onChange={(val) => {
//                                     changeHandler(val);
//                                     formik.setFieldValue("siteType", val.value);
//                                   }}
//                                 />
//                               </ToolTip>
//                             </div>
//                             <ErrorMessage
//                               name="siteType"
//                               component={TextError}
//                             />
//                           </div>
//                         </Col>
//                         <Col md={6} className="mb-3">
//                           <div className="form-group">
//                             <label className="Label mb-1">
//                               {" "}
//                               Operation Type{" "}
//                             </label>
//                             <Field
//                               name="oprationType"
//                               placeholder="Select OTP"
//                               value="Calibration Start"
//                               className="form-control"
//                               readOnly
//                             />
//                           </div>
//                         </Col>
//                         <Col md={6} className="mb-3">
//                           <div className="form-group">
//                             <label className="LabelNew mb-1">
//                               {" "}
//                               Sub Operation Type *{" "}
//                             </label>
//                             <div className="example-wrapper">
//                               <ToolTip
//                                 content="Select Sub Operation Type"
//                                 direction="bottom"
//                               >
//                                 <Select
//                                   name="subOprationType"
//                                   title="Select Sub Operation"
//                                   placeholder="Select Sub Operation"
//                                   options={startCalibration}
//                                   onChange={(e) => {
//                                     formik.setFieldValue(
//                                       "subOprationType",
//                                       e.value
//                                     );
//                                   }}
//                                 />
//                               </ToolTip>
//                             </div>
//                             <ErrorMessage
//                               name="subOprationType"
//                               component={TextError}
//                             />
//                           </div>
//                         </Col>
//                         <Col md={6} className="mb-3">
//                           <div className="form-group">
//                             <label className="Label mb-1">
//                               Service Engineer Email
//                             </label>
//                             <Field
//                               type="email"
//                               className="form-control"
//                               name="email"
//                               value={userEmailId}
//                               placeholder="Service Engineer Email"
//                               readOnly
//                             />
//                           </div>
//                         </Col>
//                         <Col md={6} className="mb-3">
//                           <div className="form-group">
//                             <label className="Label mb-1">Customer Name</label>
//                             <Field
//                               type="text"
//                               className="form-control"
//                               placeholder="Customer Name"
//                               value={allDispenserData.customerFullName}
//                               readOnly
//                             />
//                           </div>
//                         </Col>
//                         <Col md={6} className="mb-3">
//                           <div className="form-group">
//                             <label className="Label mb-1">
//                               {" "}
//                               Customer Mobile No
//                             </label>
//                             <Field
//                               type="text"
//                               name="customerMobNo"
//                               value={allDispenserData.customerMobileNo}
//                               className="form-control"
//                               placeholder="Customer Mobile No"
//                               readOnly
//                             />
//                           </div>
//                         </Col>
//                         {showdealer ? (
//                           <>
//                             <Col md={6} className="mb-3">
//                               <div className="form-group">
//                                 <label className="Label mb-1">
//                                   Dealer Name
//                                 </label>
//                                 <Field
//                                   type="text"
//                                   className="form-control"
//                                   placeholder="Enter Dealer Name "
//                                   name="dealerName"
//                                   autoComplete="off"
//                                   // value={allDispenserData.dealerName}
//                                   value={values.dealerName}
//                                   onChange={handleChange}
//                                 // readOnly
//                                 />
//                               </div>
//                             </Col>
//                             <Col md={6} className="mb-3">
//                               {/* <div className="form-group">
//                                 <label className="Label mb-1">
//                                   {" "}
//                                   Dealer Mobile No{" "}
//                                 </label>
//                                 <Field
//                                   type="text"
//                                   // name="dealerMobNo"
//                                   name="mobileNo"
//                                      maxLength="10"
//                                   className="form-control"
//                                   placeholder="Enter Dealer Mobile No"
//                                   autoComplete="off" 
//                                   // value={allDispenserData.mobileNo}
//                                   value={values.mobileNo}
//                                   onChange={handleChange} // This will allow user to edit dealer name
//                                   // readOnly
//                                 />
//                               </div>
//                               <ErrorMessage
//                               name="mobileNo"
//                               component={TextError}
//                             /> */}
//                               <div className="form-group">
//                                 <label className="Label mb-1">Dealer Mobile No</label>
//                                 <Field
//                                   type="text"
//                                   name="mobileNo"
//                                   autoComplete="off"
//                                   maxLength="10"
//                                   className={`form-control ${errors.mobileNo && touched.mobileNo ? "is-invalid" : ""
//                                     }`}
//                                   placeholder="Enter Dealer Mobile No"
//                                   validate={validateMobile}
//                                 />
//                                 <ErrorMessage name="mobileNo" component="div" className="text-danger" />
//                               </div>
//                             </Col>
//                           </>
//                         ) : null}
//                         <Col md={6} className="mb-3">
//                           <div className="form-group">
//                             <label className="Label mb-1">
//                               {" "}
//                               Dispenser Type{" "}
//                             </label>
//                             <Field
//                               type="text"
//                               className="form-control"
//                               placeholder="Dispenser Type"
//                               value={allDispenserData.modelName}
//                               readOnly
//                             />
//                           </div>
//                         </Col>

//                         <Col md={6} className="mb-3">
//                           <div className="form-group">
//                             <label className="Label mb-1">RO Country</label>
//                             <div className="example-wrapper">
//                               {/* <ToolTip
//                                 content="Select Country"
//                                 direction="bottom"
//                               >
//                                 <CountryDropdown
//                                   className="form-control"
//                                   value={country}
//                                   onChange={(val) => setCountry(val)}
//                                   priorityOptions={["IN"]}
//                                 />
//                               </ToolTip> */}

//                               <Field
//                                 type="text"
//                                 className="form-control"

//                                 value={formValues.roCountry}
//                                 readOnly
//                               />
//                             </div>
//                           </div>
//                         </Col>
//                         <Col md={6} className="mb-3">
//                           <div className="form-group">
//                             <label className="Label mb-1">RO State</label>
//                             <div className="example-wrapper">
//                               {/* <ToolTip
//                                 content="Select State"
//                                 direction="bottom"
//                               > */}
//                               {/* <RegionDropdown
//                                   className="form-control"
//                                   id="state"
//                                   // country={country}
//                                   // value={state}
//                                   // onChange={(val) => setState(val)}

//                                 /> */}
//                               {/* </ToolTip> */}

//                               <Field
//                                 type="text"
//                                 className="form-control"
//                                 // name="city"
//                                 value={formValues.roState}
//                                 readOnly
//                               />
//                             </div>
//                           </div>
//                         </Col>
//                         <Col md={6} className="mb-3">
//                           <div className="form-group">
//                             <label className="Label mb-1">RO City </label>
//                             <div className="example-wrapper">
//                               {/* <ToolTip content="Enter City" direction="bottom"> */}
//                               <Field
//                                 type="text"
//                                 className="form-control"
//                                 // name="city"
//                                 // placeholder="Enter City"
//                                 // autoComplete="off"
//                                 value={formValues.roCity}
//                                 readOnly
//                               />
//                               {/* </ToolTip> */}
//                             </div>
//                             {/* <ErrorMessage name="city" component={TextError} /> */}
//                           </div>
//                         </Col>
//                         <Col md={6} className="mb-3">
//                           <div className="form-group">
//                             <label className="Label mb-1">RO Address </label>
//                             <div className="example-wrapper">
//                               {/* <ToolTip
//                                 content="Enter Address"
//                                 direction="bottom"
//                               > */}
//                               <Field
//                                 type="text"
//                                 maxLength={100}
//                                 className="form-control"
//                                 // name="address"
//                                 // placeholder="Enter Address"
//                                 // autoComplete="off"
//                                 value={formValues.roAddress}
//                                 readOnly
//                               />
//                               {/* </ToolTip> */}
//                             </div>
//                             {/* <ErrorMessage
//                               name="address"
//                               component={TextError}
//                             /> */}
//                           </div>
//                         </Col>
//                         <Col md={6} className="mb-3">
//                           <div className="form-group">
//                             <label className="Label mb-1">RO Pincode </label>
//                             <div className="example-wrapper">
//                               <ToolTip
//                                 content="Enter Pin Code"
//                                 direction="bottom"
//                               >
//                                 <Field
//                                   type="text"
//                                   className="form-control"
//                                   name="pincode"
//                                   // placeholder="Enter Pin Code"
//                                   // maxLength="6"
//                                   // autoComplete="off"
//                                   value={formValues.pincode}
//                                   readOnly
//                                 />
//                               </ToolTip>
//                             </div>
//                             <ErrorMessage
//                               name="pincode"
//                               component={TextError}
//                             />
//                           </div>
//                         </Col>
//                         <Col md={6} className="mb-3">
//                           <div className="form-group">
//                             <label className="LabelNew mb-1">
//                               Description *
//                             </label>
//                             <div className="example-wrapper">
//                               <ToolTip
//                                 content="Enter Suitable Description"
//                                 direction="bottom"
//                               >
//                                 <Field
//                                   as="textarea"
//                                   rows="4"
//                                   maxLength={100}
//                                   className="form-control"
//                                   name="description"
//                                   placeholder="Enter Description"
//                                   autoComplete="off"
//                                 />
//                               </ToolTip>
//                             </div>
//                             <ErrorMessage
//                               name="description"
//                               component={TextError}
//                             />
//                           </div>
//                         </Col>
//                       </Row>
//                       <div className="mt-3">
//                         <Button
//                           variant="primary"
//                           type="submit"
//                           disabled={!(formik.isValid && formik.dirty) || formik.isSubmitting || !iscalibrationbutton || !dealerCheck}
//                         >
//                           Create Calibration WO
//                         </Button>
//                       </div>
//                     </Form>
//                   </Card.Body>
//                 </Card>
//               </>
//             )}
//           </>
//         );
//       }}
//     </Formik>
//   );
// };



import * as Yup from "yup";

import { Button, Card, Col, Row } from "@themesberg/react-bootstrap";
import { CountryDropdown, RegionDropdown } from "react-country-region-selector";
import { ErrorMessage, Field, Form, Formik } from "formik";
import React, { useEffect, useState, useRef } from "react";
import { selectSitetype, selectjobtype } from "../SelectOption";
import {
  getCustomerList,
  // getDealerList,
  getServiceEngineerList,
} from "../master/AllUserDropDown";
import { getListOfUserById } from "../../Service/AllAccessGetById";
import {
  getDispatchListByDispenserSrNo,
  getWorkOrderNoDropDown,
} from "../../Service/AllWorkOrder";
import {
  getDispenserDropDownListForCalibration,
  getWorkOrderCalibrationSrNo,
  postWorkOrderCalibration,
} from "../../Service/AllWorkOrderCalibrationAPI";

import DatePicker from "react-datepicker";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import Select from "react-select";
import TextError from "../TextError";
import ToolTip from "../ToolTip";
import { faClipboard } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import swal from "sweetalert";
import { useLocation } from "react-router-dom";

const pincodeRegEx = "^[1-9]{1}[0-9]{2}[0-9]{3}$"; //validate PinCode
const phoneRegEx = "^([0|+[0-9]{1,5})?([7-9][0-9]{9})$";
/* declaration of validationSchema
validation (based on the object schema provided by Yup) and display of validation errors */
const validationSchema = Yup.object({
  // serviceEngineerName: Yup.string().required("Required *"),
  jobPreference: Yup.string().required("Required *"),
  // subOprationType: Yup.string().required("Required *"),
  // siteType: Yup.string().required("Required *"),
  // siteLocation: Yup.string().required("Required *"),
  // address: Yup.string().required("Required *"),
  // mobileNo: Yup.string()
  //   .matches(/^[0-9\s]+$/, "Enter Numbers Only")
  //   .test("valid-phone", "Invalid Mobile number", (value) => {
  //     if (!value) return false;
  //     const cleanedNumber = value.replace(/\s/g, "");
  //     return /^\d{10}$/.test(cleanedNumber);
  //   })
  //   .matches(/^\d{10}$/, "Mobile number must be exactly 10 digits")
  //   .matches(phoneRegEx, "Mobile number is not valid"),
  // city: Yup.string().required("Required *")

  //   .matches(/^[A-Za-z\s]+$/, "Enter only alphabets")
  //   .min(2, "Too Short!"),
  // pincode: Yup.string()
  //   .required("Required *")
  //   .matches(pincodeRegEx, "Pincode is not valid"),
  description: Yup.string()
    .required("Required *")
    .min(4, "It should have minimum 4 characters!")
    .max(225, "It should have maximum 225 characters!"),
});
export default () => {
  const [country, setCountry] = useState("India");
  const [state, setState] = useState("");
  const [customerName, setCustomerName] = useState([]);
  // const [dealerName, setDealerName] = useState([]);
  const [userMblNo, setUserMblNo] = useState("");
  const [userEmailId, setUserEmailId] = useState("");
  const [serviceEngineerName, setServiceEngineerName] = useState([]);
  const [selectedServiceEngineer, setSelectedServiceEngineer] = useState("");
  const [jobType, setjobType] = useState("calibration");
  const [workOrderSrNo, setworkOrderSrNo] = useState("");
  // const [status, setStatus] = useState("open");
  const [workOrderNo, setWorkOrderNo] = useState([]);
  const [dispenserSrNo, setDispenserSrNo] = useState([]);
  const [selectDispenserSrNo, setSelectDispenserSrNo] = useState("");
  const [allDispenserData, setAllDispenserData] = useState({});
  // const [showdealer, setShowDealer] = useState(false);
  const [status, setStatus] = useState("ready to calibration");
  const [disabled, setdisabled] = useState(false);
  const [isLoaded, setisLoaded] = useState(false);
  const [selected, setSelected] = useState("");
  let type = null;
  const [selectedTime, setSelectedTime] = useState("");
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [siteType, setSiteType] = useState(""); // Store the siteType

  const [nozzleOptions, setNozzleOptions] = useState([]);
  const [selectedNozzle, setSelectedNozzle] = useState(null);

const clean = (v) => (v ?? "").replace(/\r?\n|\r/g, "").trim();


  const location = useLocation();


  const searchParams = new URLSearchParams(location.search);
  const dispenser = searchParams.get("dispenser") || "N/A";
  const ticketNumber = searchParams.get("ticket") || "N/A";
  const priority = searchParams.get("priority") || "N/A";
  const roCountry = searchParams.get("roCountry") || "N/A";
  const roDistrict = searchParams.get("roDistrict") || "N/A";
  const roCity = searchParams.get("roCity") || "N/A";
  const roState = searchParams.get("roState") || "N/A";
  const roAddress = searchParams.get("roAddress") || "N/A";
  const pincode = searchParams.get("pincode") || "N/A";
  const roSiteType = searchParams.get("roSiteType") || "N/A";
  const roContact = searchParams.get("roContact") || "N/A";
  const contactPerson = searchParams.get("contactPerson") || "N/A";
  const roEmail = searchParams.get("roEmail") || "N/A";
  const seName = searchParams.get("seName") || "N/A";
  const seEmail = searchParams.get("seEmail") || "N/A";
  const seContactNumber = searchParams.get("seContactNumber") || "N/A";
  const seId = searchParams.get("seId") || "N/A";
  const pkUserId = searchParams.get("pkUserId") || "N/A";
  
  // console.log("Dispenser:", dispenser);
  // console.log("Ticket Number:", ticketNumber);
  // console.log("Priority:", priority);
  // console.log("roCountry:", roCountry);
  // console.log("roCity :", roCity);
    console.log("roDistrict :", roDistrict);
  // console.log("roState:", roState);
  // console.log("roAddress", roAddress);
  // console.log("pincode", pincode);
    // console.log("roSiteType", roSiteType);
  console.log("seName", seName);
  console.log("seEmail", seEmail);
  console.log("seContactNumber", seContactNumber);
   console.log("seId", seId);

  console.log("roContact", roContact);
  console.log("contactPerson", contactPerson);
  console.log("roEmail", roEmail);
  console.log("pkUserId", pkUserId);
  // const [formValues, setFormValues] = useState({
  //   dispenserSrNo: dispenser,
  //   ticketNumber: ticketNumber,
  //   priority: priority,
  //   roCountry: roCountry,
  //   roState: roState,
  //   roAddress: roAddress,
  //   roCity: roCity,
  //   pincode: pincode,
  // });

    const [formValues, setFormValues] = useState({
    dispenserSrNo: clean(dispenser),
    ticketNumber: clean(ticketNumber),
    priority: clean(priority),
    roCountry: clean(roCountry),
    roState: clean(roState),
    roCity: clean(roCity),
    roAddress: clean(roAddress),
    pincode: clean(pincode),
    roSiteType: clean(roSiteType),
    roEmail:clean(roEmail),
    roContact: clean(roContact),
    contactPerson: clean(contactPerson),
    roDistrict: clean(roDistrict),
    seName:clean(seName),
    seContactNumber:clean(seContactNumber),
    seEmail:clean(seEmail),
    seId:clean(seId),
    pkUserId:clean(pkUserId),
    // roSiteType: clean(roSiteType),
  });
  

  const formikRef = useRef(null);

  useEffect(() => {
    const modelName = allDispenserData?.modelName;

    if (!formikRef.current) return;

    if (!modelName || !MODEL_NOZZLE_MAP[modelName]) {
      formikRef.current.setFieldValue("nozzles", []);
      return;
    }

    const count = MODEL_NOZZLE_MAP[modelName];

    const allNozzles = Array.from({ length: count }, (_, i) => `Nozzle ${i + 1}`);


    formikRef.current.setFieldValue("nozzles", allNozzles);
  }, [allDispenserData?.modelName]);




  // const changeHandler = (e) => {
  //   setSiteType(e.value); // Store the selected siteType
  //   if (e.value === "COCO") {
  //     setShowDealer(false);
  //   } else {
  //     setShowDealer(true);
  //   }
  // };

  // useEffect(() => {
  //   if (formValues.roSiteType === "COCO") {
  //     setShowDealer(false);
  //   } else {
  //     setShowDealer(true);
  //   }
  // }, [formValues.roSiteType]);

  

  // const validateMobile = (value) => {
  //   let error;
  //   if (!value) {
  //     error = "Mobile number is required";
  //   } else if (!/^[0-9\s]+$/.test(value)) {
  //     error = "Enter numbers only";
  //   } else {
  //     const cleanedNumber = value.replace(/\s/g, ""); // Remove spaces
  //     if (!/^\d{10}$/.test(cleanedNumber)) {
  //       error = "Mobile number must be exactly 10 digits";
  //     } else if (!/^[6-9]\d{9}$/.test(cleanedNumber)) {
  //       error = "Invalid mobile number ";
  //     }
  //   }
  //   return error;
  // };

  const handleTimeChange = (e) => {
    setSelectedTime(e.target.value);
  };

  const formatTimeTo12Hour = (time24) => {
    const [hour, minute, second] = time24.split(":");
    const parsedHour = parseInt(hour, 10);
    const period = parsedHour >= 12 ? "PM" : "AM";
    const formattedHour = parsedHour > 12 ? parsedHour - 12 : parsedHour;
    return `${formattedHour}:${minute}:${second} ${period}`;
  };

  const displayFormattedTime = selectedTime
    ? formatTimeTo12Hour(selectedTime)
    : "";

  // useEffect(() => {
  //   document.addEventListener("keydown", function (event) {
  //     if (event.keyCode === 13 && event.target.nodeName === "INPUT") {
  //       var form = event.target.form;
  //       var index = Array.prototype.indexOf.call(form, event.target);
  //       form.elements[index + 1].focus();
  //       event.preventDefault();
  //     }
  //   });
  // }, []);

  // added this code because of naivagiton error was coimng in ticket service page
  useEffect(() => {
    const handleEnterKey = (event) => {
      if (event.keyCode === 13 && event.target.nodeName === "INPUT") {
        const form = event.target.form;

        if (form && form.elements) {
          const index = Array.prototype.indexOf.call(form.elements, event.target);
          if (form.elements[index + 1]) {
            form.elements[index + 1].focus();
            event.preventDefault();
          }
        }
      }
    };

    document.addEventListener("keydown", handleEnterKey);

    // Cleanup listener on unmount
    return () => {
      document.removeEventListener("keydown", handleEnterKey);
    };
  }, []);



  useEffect(() => {
    if (!dispenser) return;

    console.log("CALIBRATION DISPENSER:", dispenser);

    const token = sessionStorage.getItem("token");
    const headers = { Authorization: `Bearer ${token}` };
    const operationType = "Calibration Start";

    getDispatchListByDispenserSrNo(dispenser)
      .then((res) => {
        if (!res?.data?.length) return;

        const data = res.data[0];

        console.log("Calibration Customer Data:", data);

        setAllDispenserData(data);

        // Set customer details
        setFormValues((prev) => ({
          ...prev,
          dispenserSrNo: dispenser,
          customerName: data.customerFullName || "",
          customerNumber: data.customerMobileNo || "",
        }));

        // Get Calibration Work Order SR No
        return getWorkOrderCalibrationSrNo(
          "calibration",
          operationType,
          data.customerFullName,
          headers
        );
      })
      .then((woRes) => {
        if (woRes?.data) {
          console.log("Calibration Work Order Sr No:", woRes.data);
          setworkOrderSrNo(woRes.data);
        }
      })
      .catch((err) => {
        console.error("Calibration Error:", err);
        swal("Failed", "Something went wrong", "error");
      });
  }, [dispenser]);



  useEffect(() => {
    // Function call to get customers,Dealers and  Service Engineers list
    getCustomersList();
    // getDealersList();
    getServiceEngineersList();
    getWorkOrderList();
    getDispenserSrNoAllList();
    // eslint-disable-next-line
  }, []);

  // Function declaration of get customers list
  const getCustomersList = async () => {
    await getCustomerList().then((result) => {
      setCustomerName(result);
    });
  };

  // Function declaration of get dealers list
  // const getDealersList = async () => {
  //   await getDealerList().then((result) => {
  //     setDealerName(result);
  //   });
  // };

  // Function declaration of get Service Engineers list
  const getServiceEngineersList = async () => {
    await getServiceEngineerList().then((result) => {
      setServiceEngineerName(result);
    });
  };

  const getDispenserSrNoAllList = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const headers = { Authorization: `Bearer ${token}` };
      await getDispenserDropDownListForCalibration(headers)
        .then((result) => {
          if (result?.data?.length) {
            console.log("getDispenserDDLFCalibration result :-", result);
            let tempCalibrationArray = result.data.map((obj) => {
              return {
                value: `${obj}`,
                label: `${obj}`,
              };
            }).reverse();

            setDispenserSrNo(tempCalibrationArray);
            console.log("getDispenserDDLFCalibration array :-", dispenserSrNo);
          }
        })
        .catch((error) => {
          console.log("getDispenserDDLFCalibration error :-", error);
        });
      return setDispenserSrNo;
    } catch (error) {
      console.log("getDispenserDropDownListForCalibration error :-", error);
    }
  };

  const getWorkOrderList = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const headers = { Authorization: `Bearer ${token}` };
      await getWorkOrderNoDropDown(status, headers)
        .then((result) => {
          if (result?.data?.length !== 0) {
            console.log("Work Order List", result.data);
            let tempServiceArray = result.data.map((obj) => {
              return {
                id: `${obj}`,
                value: `${obj}`,
                label: `${obj}`,
              };
            });
            setWorkOrderNo(tempServiceArray);
            console.log("Work OrderNo DropDown", result.data);
          }
        })
        .catch((error) => {
          console.log("Work Order List Error", error);
        });
      return setWorkOrderNo;
    } catch (error) {
      console.log(error);
    }
  };

  const startCalibration = [
    { value: "Nozzle 1", label: "Nozzle 1" },
    { value: "Nozzle 2", label: "Nozzle 2" },
    { value: "Nozzle 3", label: "Nozzle 3" },
    { value: "Nozzle 4", label: "Nozzle 4" },
    { value: "Nozzle 5", label: "Nozzle 5" },
    { value: "Nozzle 6", label: "Nozzle 6" },
    { value: "Nozzle 7", label: "Nozzle 7" },
    { value: "Nozzle 8", label: "Nozzle 8" },
  ];


  const MODEL_NOZZLE_MAP = {
    "1111": 1,
    "1121": 1,
    "1222": 2,
    "2222": 2,
    "2422": 4,
    "3622": 6,
    "4822": 8,
    "1242": 2,
    "2242": 2,
    "1444": 4,
    "2444": 4,
    "3644": 6,
    "4844": 8,
  };

                                               {/* 
                                                modelName 1111- nozzel 1
                                                1121-nozzel 1
                                                1222 -nozzel 1, nozzel 2,
                                                2222-nozzel 1, nozzel 2,
                                                2422-nozzel 1,nozzel 2,nozzel 3, nozzel 4,
                                                3622-nozzel 1,nozzel 2,nozzel 3, nozzel 4, nozzel 5, nozzel 6
                                                4822-nozzel 1, nozzel 2,nozzel 3, nozzel 4, nozzel 5, nozzel 6,nozzel 7, nozzel 8
                                                1242-nozzel 1,nozzel 2
                                                2242-nozzel 1,nozzel 2
                                                1444-nozzel 1, nozzel 2,nozzel 3, nozzel 4,
                                                2444-nozzel 1,nozzel 2,nozzel 3, nozzel 4,
                                                3644-nozzel 1,nozzel 2,nozzel 3, nozzel 4, nozzel 5, nozzel 6,
                                                4844-nozzel 1,nozzel 2,nozzel 3, nozzel 4, nozzel 5, nozzel 6,nozzel 7, nozzel 8
                                                
                                                
                                                */}
  return (
    <Formik //Formik provides the Form, Field and ErrorMessage
      innerRef={formikRef}
      initialValues={{
        //declaration of initialValues
        generateUniqueDispenserNo: "",
        calibrationDate: "",
        calibrationTime: "",
        serviceEngineerName: "",
        serviceEngineerMobNo: "",
        fkRoManagerId:"",
        // RoManagerEmail:"",
        // RoManagerMobNo:"",
        // RoManagerName:"",

         roManagerName:"",
        roManagerEmail:"",
        roManagerMobNo:"",
        siteLocation: "",
        siteType: "",
        email: "",
        customerName: "",
        customerMobNo: "",
        jobPreference: "",
        oprationType: "",
        subOprationType:"",
        // subOprationType: [],
        nozzles: [],

        customerMobNo: "",
        // dealerName: "",
        // dealerMobNo: "",
        // dealerName: allDispenserData.dealerName || "",
        // mobileNo: allDispenserData?.mobileNo || "",
        dispenserType: "",
        district:"",
        city: "",
        address: "",
        description: "",
        pincode: "",
        dispenserSrNo: "",
        ticketNumber: "",
        priority: "",
        roCountry: "",
        roCity: "",
        roState: "",
        roAddress: "",
      }}
      validationSchema={validationSchema} // function call to validationSchema
      onSubmit={async (values, { resetForm }) => {
        // declaration of onSubmit callback
        try {
          setisLoaded(true);
          setdisabled(true);
          let role = sessionStorage.getItem("role");
          let pkUserId = sessionStorage.getItem("pkUserId");
          // code that we will 'try' to run
          const data = {
            // All Object for add calibration data
            workOrderSerialNo: workOrderSrNo,
            // generateUniqueDispenserNo: values.generateUniqueDispenserNo,
            calibrationDate: moment(selectedDate, "DD/MMM/yyyy").format(
              "yyyy-MM-DD"
            ),
            calibrationTime: moment(displayFormattedTime, "hh:mm:ss A").format(
              "hh:mm:ss A"
            ),
            fkServiceEngineerId: formValues.seId,
            fkCustomerId: allDispenserData.fkCustomerId,
            // fkDealerId: allDispenserData.fkDealerId,
            fkBackOfficeId: role === "back office" ? pkUserId : "",
            // serviceEngineerName: values.serviceEngineerName,
            // serviceEngineerMobNo: userMblNo,
            serviceEngineerName:formValues.seName,
            serviceEngineerMobNo:formValues.seContactNumber,
            roManagerName:formValues.contactPerson,
            roManagerMobNo:formValues.roContact,
            roManagerEmail:formValues.roEmail,
            fkRoManagerId:formValues.pkUserId,
            // email: userEmailId,
             email: formValues.seEmail,
            // siteLocation: values.siteLocation,
            siteLocation:formValues.roAddress,
            oprationType: "Calibration Start",
            subOprationType: values.subOprationType,
            // subOprationType: values.nozzles,
            nozzles: values.nozzles,
            siteType: formValues.roSiteType,
            // siteType: values.siteType,
            customerName: allDispenserData.customerFullName,
            customerMobNo: allDispenserData.customerMobileNo,
            // customerName:formValues.contactPerson,
            // customerMobNo:formValues.roContact,
            // dealerName: allDispenserData.dealerName,
            // dealerMobNo: allDispenserData.mobileNo,
            // dealerName: values.siteType === "COCO" ? "" : values.dealerName, // Set null if COCO
            // dealerMobNo: values.siteType === "COCO" ? "" : values.mobileNo, // Set null if COCO
            dispenserType: allDispenserData.modelName,
            jobType: jobType,
            jobPreference: values.jobPreference,
            country: formValues.roCountry,
            state: formValues.roState,
            district:formValues.roDistrict,
            city: formValues.roCity,
            address:formValues.roAddress,
            pincode: formValues.pincode,
            description: values.description,
            // generateUniqueDispenserNo: formValues.dispenserSrNo,
            generateUniqueDispenserNo: clean(formValues.dispenserSrNo),
            ticketNumber: formValues.ticketNumber,
            priority: formValues.priority,
            roCity: formValues.roCity,
            roAddress: formValues.roAddress,
            roState: formValues.roState,
            roCountry: formValues.roCountry,
            // pincode: formValues.pincode,
            // status: status
          };
          console.log("Work Order Calibration Data", data);

          await postWorkOrderCalibration(data)
            .then((result) => {

              setisLoaded(false);
              console.log("Work Order Calibration Result", result);
              swal("Great", "Calibration Work order created successfully...", "success");
              resetForm()
              // setTimeout(() => {
              //   resetForm();
              //   window.location.href = '/Callcenter/TicketServiceTech ';
              // }, 5000);
            })
            .catch((error) => {
              setisLoaded(false);
              //code to run if there are any problems
              console.log("Work Order Calibration Error", error);
              swal(
                "Failed",
                "Something went wrong please check your internet",
                "error"
              );
              if (error.response.status === 400) {
                console.log("error.response.data :-", error.response.data);
                let calibVal = error?.response?.data;
                if (calibVal?.generateUniqueDispenserNo !== undefined) {
                  swal("Failed", "Please Select Dispenser No", "warning");
                  return false;
                }
                if (calibVal?.serviceEngineerName !== undefined) {
                  swal(
                    "Failed",
                    "Please Select Service Engineer name",
                    "warning"
                  );
                  return false;
                }
                if (calibVal?.serviceEngineerMobNo !== undefined) {
                  swal(
                    "Failed",
                    "Please Enter Service Engineer Mobile No",
                    "warning"
                  );
                  return false;
                }
                if (calibVal?.siteType !== undefined) {
                  swal("Failed", "Please Select Site Type", "warning");
                  return false;
                }
                if (calibVal?.dispenserType !== undefined) {
                  swal("Failed", "Please Enter Dispenser Type", "warning");
                  return false;
                }
                // if (calibVal?.country !== undefined) {
                //   swal("Failed", "Please Select Country", "warning");
                //   return false;
                // }
                // if (calibVal?.state !== undefined) {
                //   swal("Failed", "Please Select State", "warning");
                //   return false;
                // }
                // if (calibVal?.city !== undefined) {
                //   swal("Failed", "Please Enter city", "warning");
                //   return false;
                // }
                if (calibVal?.pincode !== undefined) {
                  swal("Failed", "Please Enter Pincode", "warning");
                  return false;
                }
              } else {
                swal(
                  "Failed",
                  "Something went wrong please check your internet",
                  "error"
                );
              }
            });
        } catch (error) {
          console.log(error);
          setisLoaded(false);
          swal(
            "Failed",
            "Something went wrong please check your internet",
            "error"
          );
        }
      }}
    >
      {(formik) => {
        //Formik provides the Form, Field and ErrorMessage
        const { isValid, dirty, isSubmitting, handleChange, values, setFieldValue, errors, touched } = formik;
        const iscalibrationbutton = selectedDate && displayFormattedTime
      
        // const dealerCheck =  formValues.roSiteType  !== "COCO"
        //   ? values.dealerName && values.mobileNo
        //   : true;  

        // useEffect(() => {
        //   if (allDispenserData?.dealerName) {
        //     setFieldValue("dealerName", allDispenserData.dealerName);
        //   }
        //   if (allDispenserData?.mobileNo) {
        //     setFieldValue("mobileNo", allDispenserData.mobileNo);
        //   }
        // }, [allDispenserData, setFieldValue]);

        return (
          <>
            {isLoaded ? (
              <div className="reportload"></div>
            ) : (
              <>
                <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
                  <div className="d-flex">
                    <Link
                      to="calibration-list"
                      className="fieldLink btn btn-primary"
                    >
                      <FontAwesomeIcon icon={faClipboard} className="me-2" />{" "}
                      Reports
                      <span className="icon icon-small ms-1"></span>
                    </Link>
                  </div>
                </div>
                <Card border="light" className="bg-white shadow-sm mb-4">
                  <Card.Body>
                    <h5 className="head mb-4">Create Calibration Work Order</h5>
                    <h5 className="SrNo mb-4" align="right">
                      Calibration Sr No : {workOrderSrNo}
                    </h5>
                    {/* react-final-form */}
                    <Form>
                      <Row>
                        

                        <Col md={6} className="mb-3">


                          <div className="form-group">
                            <label className="Label mb-1">
                              Dispenser Sr No

                            </label>
                            <Field
                              type="text"
                              className="form-control"
                              placeholder="Dispenser Type"
                              value={formValues.dispenserSrNo}
                              readOnly
                            />
                          </div>
                        </Col>


                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="Label mb-1">
                              Ticket Number
                            </label>
                            <Field
                              type="text"
                              className="form-control"
                              placeholder="Dispenser Type"
                              value={formValues.ticketNumber}
                              readOnly
                            />
                          </div>
                        </Col>

                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="Label mb-1">
                              Priority

                            </label>
                            <Field
                              type="text"
                              className="form-control"
                              placeholder="Dispenser Type"
                              value={formValues.priority}
                              readOnly
                            />
                          </div>
                        </Col>

                         <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="Label mb-1">
                              {" "}
                             Dispenser Config{" "}
                            </label>
                            <Field
                              type="text"
                              className="form-control"
                              placeholder=" Dispenser Config"
                              value={allDispenserData.modelName}
                              readOnly
                            />
                          </div>
                        </Col>

                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="LabelNew mb-1">
                              {" "}
                              Calibration Date *{" "}
                            </label>
                            <br />
                            <div className="example-wrapper">
                              <ToolTip
                                content="Select Calibration Date"
                                direction="bottom"
                              >
                                <DatePicker
                                  showIcon
                                  closeOnScroll={true}
                                  className="form-control"
                                  dateFormat="dd-MMM-yyyy"
                                  placeholderText="Select Date"
                                  selected={selectedDate}
                                  onChange={(date) => {
                                    setSelectedDate(date);
                                  }}
                                  // minDate={new Date()} // Set the minimum selectable date to today
                                />
                              </ToolTip>
                            </div>
                          </div>
                        </Col>
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="LabelNew mb-1">
                              {" "}
                              Calibration Time *{" "}
                            </label>
                            <br />
                            <div className="time-wrapper">
                              <div className="allTime">
                                <input
                                  type="time"
                                  onChange={handleTimeChange}
                                  className="form-control"
                                  step="1"
                                />
                              </div>
                              <div className="addTime">
                                <div className="example-wrapper">
                                  <ToolTip
                                    content="Select Time from Widget"
                                    direction="bottom"
                                  >
                                    <Field
                                      className="form-control"
                                      name="calibrationTime"
                                      placeholder="Select Time from Widget"
                                      value={displayFormattedTime}
                                      readOnly
                                    />
                                  </ToolTip>
                                </div>
                              </div>
                            </div>
                          </div>
                        </Col>

                         {/* <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="Label mb-1">
                              {" "}
                              Dispenser Type{" "}
                            </label>
                            <Field
                              type="text"
                              className="form-control"
                              placeholder="Dispenser Type"
                              value={allDispenserData.modelName}
                              readOnly
                            />
                          </div>
                        </Col>  */}


                         {/* <Col md={6} className="mb-3">
                          <label>Nozzles</label>

                          <Select
                            isMulti
                            isClearable
                            placeholder="Select Nozzles"
                            options={
                              MODEL_NOZZLE_MAP[formik.values.dispenserSrNo?.[0]?.modelName]
                                ? Array.from(
                                  { length: MODEL_NOZZLE_MAP[formik.values.dispenserSrNo[0].modelName] },
                                  (_, i) => ({
                                    value: `Nozzle ${i + 1}`,
                                    label: `Nozzle ${i + 1}`,
                                  })
                                )
                                : []
                            }
                            value={formik.values.nozzles.map(n => ({
                              value: n,
                              label: n,
                            }))}
                            onChange={(selected) =>
                              formik.setFieldValue(
                                "nozzles",
                                selected ? selected.map(s => s.value) : []
                              )
                            }
                          />


                        </Col> */}
 

{/*                      
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="LabelNew mb-1">
                              {" "}
                              Service Engineer Name *{" "}
                            </label>
                            <div className="example-wrapper">
                              <ToolTip
                                content="Select Service Engineer Name"
                                direction="bottom"
                              >
                                <Select
                                  placeholder="Select Service Engineer Name"
                                  options={serviceEngineerName}
                                  onChange={async (e) => {
                                    formik.setFieldValue(
                                      "serviceEngineerName",
                                      e.value
                                    );
                                    setSelectedServiceEngineer(e.id);
                                    const token =
                                      sessionStorage.getItem("token");
                                    const headers = {
                                      Authorization: `Bearer ${token}`,
                                    };
                                    await getListOfUserById(e.id, headers).then(
                                      (result) => {
                                        console.log(
                                          "getListOfUserById",
                                          result.data
                                        );
                                        setUserMblNo(result.data.mobileNo);
                                        setUserEmailId(result.data.email);
                                      }
                                    );
                                  }}
                                />
                              </ToolTip>
                            </div>
                            <ErrorMessage
                              name="serviceEngineerName"
                              component={TextError}
                            />
                          </div>
                        </Col>
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="Label mb-1">
                              {" "}
                              Service Engineer Mobile No{" "}
                            </label>
                            <Field
                              type="text"
                              className="form-control"
                              name="serviceEngineerMobNo"
                              value={userMblNo}
                              placeholder="Mobile No."
                              readOnly
                            />
                          </div>
                        </Col> */}

                         <Col md={6} className="mb-3">
                   
                          <div className="form-group">
                            <label className="Label mb-1">  Service Engineer Name</label>
                            <div className="example-wrapper">
                       
                       
                              <Field
                                type="text"
                                className="form-control"
                            
                                
                                value={formValues.seName} 
                                readOnly
                              />
                         
                            </div>
                          
                          </div>

                         </Col>

                        <Col md={6} className="mb-3">
                       

                           <div className="form-group">
                            <label className="Label mb-1">  Service Engineer Mobile No</label>
                            <div className="example-wrapper">
                            
                              <Field
                                type="text"
                                className="form-control"
                              
                                value={formValues.seContactNumber } 
                                readOnly
                              />
                          
                            </div>
                         
                          </div>


                        </Col>

                         {/* <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="Label mb-1">
                              Service Engineer Email
                            </label>
                            <Field
                              type="email"
                              className="form-control"
                              name="email"
                              value={userEmailId}
                              placeholder="Service Engineer Email"
                              readOnly
                            />
                          </div>
                        </Col> */}

                        <Col md={6} className="mb-3">
                       

                           <div className="form-group">
                            <label className="Label mb-1">   Service Engineer Email</label>
                            <div className="example-wrapper">
                            
                              <Field
                                type="text"
                                className="form-control"
                              
                                value={formValues.seEmail } 
                                readOnly
                              />
                          
                            </div>
                         
                          </div>
                        </Col>

                          <Col md={6} className="mb-3">
                            <div className="form-group">
                              <label className="Label mb-1">Ro Manager Name </label>
                              <div className="example-wrapper">

                                <Field
                                  type="text"
                                  className="form-control"

                                  value={formValues.contactPerson}
                                  readOnly
                                />

                              </div>

                            </div>
                          </Col>

                          <Col md={6} className="mb-3">
                            <div className="form-group">
                              <label className="Label mb-1">Ro Manager Mobile Number </label>
                              <div className="example-wrapper">

                                <Field
                                  type="text"
                                  className="form-control"

                                  value={formValues.roContact}
                                  readOnly
                                />

                              </div>

                            </div>
                          </Col>

                          <Col md={6} className="mb-3">
                            <div className="form-group">
                              <label className="Label mb-1">Ro Manager Email </label>
                              <div className="example-wrapper">

                                <Field
                                  type="text"
                                  className="form-control"

                                  value={formValues.roEmail}
                                  readOnly
                                />

                              </div>

                            </div>
                          </Col>

                       
                        {/* <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="LabelNew mb-1">
                              Site Location *
                            </label>
                            <div className="example-wrapper">
                              <ToolTip
                                content="Enter site location"
                                direction="bottom"
                              >
                                <Field
                                  type="text"
                                  className="form-control"
                                  name="siteLocation"
                                  placeholder="Enter Site Location"
                                  autoComplete="off"
                                />
                              </ToolTip>
                            </div>
                            <ErrorMessage
                              name="siteLocation"
                              component={TextError}
                            />
                          </div>
                        </Col> */}
                        {/* <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="LabelNew mb-1">Site Type *</label>
                            <div className="example-wrapper">
                              <ToolTip
                                content="Select Site Type"
                                direction="bottom"
                              >
                                <Select
                                  placeholder="Select Site Type"
                                  options={selectSitetype}
                                  onChange={(val) => {
                                    changeHandler(val);
                                    formik.setFieldValue("siteType", val.value);
                                  }}
                                />
                              </ToolTip>
                            </div>
                            <ErrorMessage
                              name="siteType"
                              component={TextError}
                            />
                          </div>
                        </Col> */}


                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="Label mb-1">
                              {" "}
                              Operation Type{" "}
                            </label>
                            <Field
                              name="oprationType"
                              placeholder="Select OTP"
                              value="Calibration Start"
                              className="form-control"
                              readOnly
                            />
                          </div>
                        </Col>
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="LabelNew mb-1">
                              {" "}
                              Sub Operation Type *{" "}
                            </label>
                            <div className="example-wrapper">
                              <ToolTip
                                content="Select Sub Operation Type"
                                direction="bottom"
                              >
                                <Select
                                  name="subOprationType"
                                  title="Select Sub Operation"
                                  placeholder="Select Sub Operation"
                                  options={startCalibration}
                                  onChange={(e) => {
                                    formik.setFieldValue(
                                      "subOprationType",
                                      e.value
                                    );
                                  }}
                                />
                              </ToolTip>
                            </div>
                            <ErrorMessage
                              name="subOprationType"
                              component={TextError}
                            />
                          </div>
                        </Col>  
                         <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="LabelNew mb-1">
                              Job Reference
                            </label>
                            <div className="example-wrapper">
                              <ToolTip
                                content="Select Job Reference"
                                direction="bottom"
                              >
                                <Select
                                  placeholder="Select Job Reference"
                                  options={selectjobtype}
                                  onChange={(e) => {
                                    formik.setFieldValue(
                                      "jobPreference",
                                      e.value
                                    );
                                  }}
                                />
                              </ToolTip>
                            </div>
                            <ErrorMessage
                              name="jobPreference"
                              component={TextError}
                            />
                          </div>
                        </Col>
                        
                           <Col md={6} className="mb-3">
                         <div className="form-group">
                               <label className="Labelmb-1">Site Type </label>
                            <div className="example-wrapper">
                          
                                <Field
                                  type="text"
                                  className="form-control"
                             
                               value={formValues.roSiteType}
                              readOnly
                                />
                            
                            </div>
                            <ErrorMessage name="roSiteType" component={TextError} />
                          </div>
                        </Col>
                       
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="Label mb-1">Customer Name</label>
                            <Field
                              type="text"
                              className="form-control"
                              placeholder="Customer Name"
                              value={allDispenserData.customerFullName}
                              //  value={formValues.contactPerson}
                              readOnly
                            />
                          </div>
                        </Col>
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="Label mb-1">
                              {" "}
                              Customer Mobile No
                            </label>
                            <Field
                              type="text"
                              name="customerMobNo"
                              value={allDispenserData.customerMobileNo}
                              // value={formValues.roContact}
                              className="form-control"
                              placeholder="Customer Mobile No"
                              readOnly
                            />
                          </div>
                        </Col>
                        {/* {showdealer ? (
                          <>
                            <Col md={6} className="mb-3">
                              <div className="form-group">
                                <label className="Label mb-1">
                                  Dealer Name
                                </label>
                                <Field
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter Dealer Name "
                                  name="dealerName"
                                  autoComplete="off"
                                  // value={allDispenserData.dealerName}
                                  value={values.dealerName}
                                  onChange={handleChange}
                                // readOnly
                                />
                              </div>
                            </Col>
                            <Col md={6} className="mb-3">
                              <div className="form-group">
                                <label className="Label mb-1">Dealer Mobile No</label>
                                <Field
                                  type="text"
                                  name="mobileNo"
                                  autoComplete="off"
                                  maxLength="10"
                                  className={`form-control ${errors.mobileNo && touched.mobileNo ? "is-invalid" : ""
                                    }`}
                                  placeholder="Enter Dealer Mobile No"
                                  validate={validateMobile}
                                />
                                <ErrorMessage name="mobileNo" component="div" className="text-danger" />
                              </div>
                            </Col>
                          </>
                        ) : null} */}
                       
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="Label mb-1">RO Country</label>
                            <div className="example-wrapper">
                              {/* <ToolTip
                                content="Select Country"
                                direction="bottom"
                              >
                                <CountryDropdown
                                  className="form-control"
                                  value={country}
                                  onChange={(val) => setCountry(val)}
                                  priorityOptions={["IN"]}
                                />
                              </ToolTip> */}

                              <Field
                                type="text"
                                className="form-control"

                                value={formValues.roCountry}
                                readOnly
                              />
                            </div>
                          </div>
                        </Col>
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="Label mb-1">RO State</label>
                            <div className="example-wrapper">
                              {/* <ToolTip
                                content="Select State"
                                direction="bottom"
                              > */}
                              {/* <RegionDropdown
                                  className="form-control"
                                  id="state"
                                  // country={country}
                                  // value={state}
                                  // onChange={(val) => setState(val)}
                                  
                                /> */}
                              {/* </ToolTip> */}

                              <Field
                                type="text"
                                className="form-control"
                                // name="city"
                                value={formValues.roState}
                                readOnly
                              />
                            </div>
                          </div>
                        </Col>

                         <Col md={6} className="mb-3">
                            <div className="form-group">
                            <label className="Label mb-1">RO District</label>
                            <div className="example-wrapper">
                         
                                <Field
                                  type="text"
                                  className="form-control"
                                  value={formValues.roDistrict}
                                  readOnly
                                />
                              {/* </ToolTip> */}
                            </div>
                            <ErrorMessage name="city" component={TextError} />
                          </div>
                          </Col>
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="Label mb-1">RO City </label>
                            <div className="example-wrapper">
                              {/* <ToolTip content="Enter City" direction="bottom"> */}
                              <Field
                                type="text"
                                className="form-control"
                                // name="city"
                                // placeholder="Enter City"
                                // autoComplete="off"
                                value={formValues.roCity}
                                readOnly
                              />
                              {/* </ToolTip> */}
                            </div>
                            {/* <ErrorMessage name="city" component={TextError} /> */}
                          </div>
                        </Col>
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="Label mb-1">RO Address </label>
                            <div className="example-wrapper">
                              {/* <ToolTip
                                content="Enter Address"
                                direction="bottom"
                              > */}
                              <Field
                                type="text"
                                maxLength={100}
                                className="form-control"
                                // name="address"
                                // placeholder="Enter Address"
                                // autoComplete="off"
                                value={formValues.roAddress}
                                readOnly
                              />
                              {/* </ToolTip> */}
                            </div>
                            {/* <ErrorMessage
                              name="address"
                              component={TextError}
                            /> */}
                          </div>
                        </Col>
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="Label mb-1">RO Pincode </label>
                            <div className="example-wrapper">
                              <ToolTip
                                content="Enter Pin Code"
                                direction="bottom"
                              >
                                <Field
                                  type="text"
                                  className="form-control"
                                  name="pincode"
                                  // placeholder="Enter Pin Code"
                                  // maxLength="6"
                                  // autoComplete="off"
                                  value={formValues.pincode}
                                  readOnly
                                />
                              </ToolTip>
                            </div>
                            <ErrorMessage
                              name="pincode"
                              component={TextError}
                            />
                          </div>
                        </Col>

                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="LabelNew mb-1">
                              Description *
                            </label>
                            <div className="example-wrapper">
                              <ToolTip
                                content="Enter Suitable Description"
                                direction="bottom"
                              >
                                <Field
                                  as="textarea"
                                  rows="4"
                                  maxLength={100}
                                  className="form-control"
                                  name="description"
                                  placeholder="Enter Description"
                                  autoComplete="off"
                                />
                              </ToolTip>
                            </div>
                            <ErrorMessage
                              name="description"
                              component={TextError}
                            />
                          </div>
                        </Col>
                      </Row>
                      <div className="mt-3">
                        <Button
                          variant="primary"
                          type="submit"
                          disabled={!(formik.isValid && formik.dirty) || formik.isSubmitting || !iscalibrationbutton /* || !dealerCheck */}
                        >
                          Create Calibration WO
                        </Button>
                      </div>
                    </Form>
                  </Card.Body>
                </Card>
              </>
            )}
          </>
        );
      }}
    </Formik>
  );
};

